import { writeFile, utils, write } from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { canonicalSchoolName } from "../constants/schoolNameGroups";
import {
  exportAllExcel,
  exportExcelState,
  exportExcelMoe,
  exportExcelFinalMoe,
  exportExcelAct1,
  exportExcelAct1MoePending,
  exportExcelAct2,
  exportExcelAct2MoePending,
  exportAct1TopAchieversReport,
  exportAct2TopAchieversReport,
  exportAct1AllGradesReport,
  exportAct2AllGradesReport,
  exportUniversitiesReport,
  exportAllInvoicesReport,
  exportShippingReport,
  exportMoheStatementReport,
  exportRushReport,
  exportMoheReport,
  exportCertificateReceiversReport,
  exportCollegesReport,
  exportSchoolsStateReport,
  exportMissingEnrollmentLettersReport,
  getCountryActualCounts,
  getEnrollmentLetterHistoryExport,
  getTopAchieversGuests,
} from "../actions/studensts";

export async function exportToExcel(selectState) {
  if (selectState === "all") {
    // console.log("here will setup exportAllToExcel");
    const { data } = await exportAllExcel();
    const all_student = data.data;
    const workSheet = utils.json_to_sheet(all_student);
    const workBook = utils.book_new();
    utils.book_append_sheet(workBook, workSheet, "all_student");
    write(workBook, { bookType: "xlsx", type: "buffer" });
    write(workBook, { bookType: "xlsx", type: "binary" });
    writeFile(workBook, "all_student.xlsx");
  } else {
    //  console.log("here will setup exportToExcelWithState");
    const { data } = await exportExcelState(selectState);
    const stateFilter = data.data;
    const workSheet = utils.json_to_sheet(stateFilter);
    const workBook = utils.book_new();
    utils.book_append_sheet(workBook, workSheet, "student_state");
    write(workBook, { bookType: "xlsx", type: "buffer" });
    write(workBook, { bookType: "xlsx", type: "binary" });
    writeFile(workBook, `${"student_state_" + selectState + ".xlsx"}`);
  }
}

export async function excelMoe() {
  const { data } = await exportExcelMoe();
  const moe_student = data.data;
  const workSheet = utils.json_to_sheet(moe_student);
  const workBook = utils.book_new();
  utils.book_append_sheet(workBook, workSheet, "moe_student");
  write(workBook, { bookType: "xlsx", type: "buffer" });
  write(workBook, { bookType: "xlsx", type: "binary" });
  writeFile(workBook, "moe_student.xlsx");
}

export async function excelFinalMoe() {
  const { data } = await exportExcelFinalMoe();
  const final_student = data.data;
  const workSheet = utils.json_to_sheet(final_student);
  const workBook = utils.book_new();
  utils.book_append_sheet(workBook, workSheet, "final_student");
  write(workBook, { bookType: "xlsx", type: "buffer" });
  write(workBook, { bookType: "xlsx", type: "binary" });
  writeFile(workBook, "final_student.xlsx");
}

export async function excelActOne() {
  const { data } = await exportExcelAct1();
  const act1_student = data.data;
  const workSheet = utils.json_to_sheet(act1_student);
  const workBook = utils.book_new();
  utils.book_append_sheet(workBook, workSheet, "act1_student");
  write(workBook, { bookType: "xlsx", type: "buffer" });
  write(workBook, { bookType: "xlsx", type: "binary" });
  writeFile(workBook, "act1_student.xlsx");
}

export async function excelAct1MoePending() {
  const { data } = await exportExcelAct1MoePending();
  const act1_student = data.data;
  const workSheet = utils.json_to_sheet(act1_student);
  const workBook = utils.book_new();
  utils.book_append_sheet(workBook, workSheet, "act1_moe_pending");
  write(workBook, { bookType: "xlsx", type: "buffer" });
  write(workBook, { bookType: "xlsx", type: "binary" });
  writeFile(workBook, "act1_moe_pending.xlsx");
}

export async function excelActTwo() {
  const { data } = await exportExcelAct2();
  const act2_student = data.data;
  const workSheet = utils.json_to_sheet(act2_student);
  const workBook = utils.book_new();
  utils.book_append_sheet(workBook, workSheet, "act2_student");
  write(workBook, { bookType: "xlsx", type: "buffer" });
  write(workBook, { bookType: "xlsx", type: "binary" });
  writeFile(workBook, "act2_student.xlsx");
}

export async function excelAct2MoePending() {
  const { data } = await exportExcelAct2MoePending();
  const act2_student = data.data;
  const workSheet = utils.json_to_sheet(act2_student);
  const workBook = utils.book_new();
  utils.book_append_sheet(workBook, workSheet, "act2_moe_pending");
  write(workBook, { bookType: "xlsx", type: "buffer" });
  write(workBook, { bookType: "xlsx", type: "binary" });
  writeFile(workBook, "act2_moe_pending.xlsx");
}

// Normalised key for a school name (case / spacing insensitive). Shared with
// the Merge Schools modal so its choices line up with the export.
export const schoolKey = (s) => (s || "").trim().replace(/\s+/g, " ").toLowerCase();

// Fetches the ACT 1 / ACT 2 Top Achievers rows once, so the Merge Schools
// modal and the export use the same data. Returns null (after alerting) on error.
export async function fetchTopAchieversData(dateFrom, dateTo, scoreFrom = 30, scoreTo = 36) {
  // The score range comes from the export filter. Normalise it here too so the
  // labels printed in the workbook match the range the server actually applied.
  const clampScore = (v, fallback) => {
    const n = Number(v);
    if (!Number.isFinite(n)) return fallback;
    return Math.min(36, Math.max(1, Math.round(n)));
  };
  const rawFrom = clampScore(scoreFrom, 30);
  const rawTo = clampScore(scoreTo, 36);
  const minScore = Math.min(rawFrom, rawTo);
  const maxScore = Math.max(rawFrom, rawTo);

  // Fetch ACT1 and ACT2 data in parallel
  const [resAct2, resAct1] = await Promise.all([
    exportAct2TopAchieversReport(dateFrom, dateTo, minScore, maxScore),
    exportAct1TopAchieversReport(dateFrom, dateTo, minScore, maxScore),
  ]);

  if (!resAct2 || resAct2.status !== 200) {
    alert("Failed to fetch ACT 2 data. Please try again.");
    return null;
  }
  if (!resAct1 || resAct1.status !== 200) {
    alert("Failed to fetch ACT 1 data. Please try again.");
    return null;
  }

  return {
    minScore,
    maxScore,
    act1Rows: resAct1.data.data || [],
    act2Rows: resAct2.data.data || [],
  };
}

// Every school in the Top Achievers data, for the Merge Schools modal:
// [{ key, name, city, ids: [national ids] }] sorted by student count desc.
export function listTopAchieversSchools({ act1Rows, act2Rows }) {
  const map = new Map();
  for (const r of [...act1Rows, ...act2Rows]) {
    const name = (r["School Name"] || "").trim().replace(/\s+/g, " ") || "Unknown";
    const key = schoolKey(name);
    if (!map.has(key)) map.set(key, { key, name, cities: new Set(), ids: new Set() });
    const entry = map.get(key);
    if (r["School City"]) entry.cities.add(String(r["School City"]).trim());
    entry.ids.add(r["National ID"]);
  }
  return [...map.values()]
    .map(({ key, name, cities, ids }) => ({ key, name, city: [...cities].join(" / "), ids: [...ids] }))
    .sort((a, b) => b.ids.length - a.ids.length || a.name.localeCompare(b.name));
}

// schoolMerge: { [schoolKey(original name)]: merged display name } chosen in
// the Merge Schools modal. When given, it alone decides the Schools Ranking
// rows ({} = no merging). When omitted, the automatic rules in
// constants/schoolNameGroups.js are used. `prefetched` reuses data from
// fetchTopAchieversData so the server isn't queried twice.
export async function excelAct2TopAchievers(
  dateFrom, dateTo, scoreFrom = 30, scoreTo = 36,
  { prefetched = null, schoolMerge = null } = {}
) {
  const data = prefetched || (await fetchTopAchieversData(dateFrom, dateTo, scoreFrom, scoreTo));
  if (!data) return;
  const { minScore, maxScore, act1Rows, act2Rows } = data;

  // ---- date formatters ----
  const fmtDate = (val) => {
    if (!val) return "";
    const s = val instanceof Date ? val.toISOString().slice(0, 10) : String(val).slice(0, 10);
    const [y, m, d] = s.split("-").map(Number);
    if (!y || !m || !d) return String(val);
    return new Date(y, m - 1, d).toLocaleDateString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
    });
  };
  const fmtInputDate = (yyyymmdd) => {
    if (!yyyymmdd) return "";
    const [y, m, d] = yyyymmdd.split("-").map(Number);
    return new Date(y, m - 1, d).toLocaleDateString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
    });
  };
  // Normalize → lowercase map key; title-case → display label
  const normKey = (s) => (s || "").trim().replace(/\s+/g, " ").toLowerCase();
  const toTitle = (s) =>
    (s || "")
      .trim()
      .replace(/\s+/g, " ")
      .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());

  // ---- build combined summary across ACT1 + ACT2 ----
  // bySchoolGrouped: locKey → { locLabel, schools: Map<schoolKey, {label, act1ids, act2ids}> }
  const bySchoolGrouped = new Map();
  const byCityCountry   = new Map();
  const byCountry       = new Map();

  const addToMaps = (row, examType) => {
    const id      = row["National ID"];
    const school  = toTitle(row["School Name"]) || "Unknown";
    const city    = toTitle(row["School City"]);
    const country = toTitle(row["Country"]);
    const locLabel = [city, country].filter(Boolean).join(", ") || "Unknown";
    const locKey   = normKey(locLabel);
    const schoolKey = normKey(school);
    const bucket   = examType === "act1" ? "act1ids" : "act2ids";

    // grouped schools
    if (!bySchoolGrouped.has(locKey))
      bySchoolGrouped.set(locKey, { locLabel, schools: new Map() });
    const loc = bySchoolGrouped.get(locKey);
    if (!loc.schools.has(schoolKey))
      loc.schools.set(schoolKey, { label: school, act1ids: new Set(), act2ids: new Set() });
    loc.schools.get(schoolKey)[bucket].add(id);

    // city/country & country summaries
    const upsert = (map, key, label) => {
      if (!map.has(key)) map.set(key, { label, act1ids: new Set(), act2ids: new Set() });
      map.get(key)[bucket].add(id);
    };
    upsert(byCityCountry, locKey, locLabel);
    upsert(byCountry, normKey(country || "Unknown"), country || "Unknown");
  };

  act1Rows.forEach((r) => addToMaps(r, "act1"));
  act2Rows.forEach((r) => addToMaps(r, "act2"));

  // Convert city/country & country maps → sorted arrays [label, act1, act2, total]
  const toSortedArray = (map) =>
    [...map.values()]
      .map(({ label, act1ids, act2ids }) => {
        const total = act1ids.size + act2ids.size;
        return [label, act1ids.size, act2ids.size, total];
      })
      .sort((a, b) => b[3] - a[3]);

  const citySummary    = toSortedArray(byCityCountry);
  const countrySummary = toSortedArray(byCountry);

  // Build flat schoolRows: interleaved location-header and school-data entries
  // Locations sorted by their total count desc; schools within each location also sorted desc
  const schoolRows = [];
  const sortedLocs = [...bySchoolGrouped.values()]
    .map((loc) => {
      const locTotal = [...loc.schools.values()]
        .reduce((sum, s) => sum + s.act1ids.size + s.act2ids.size, 0);
      return { ...loc, locTotal };
    })
    .sort((a, b) => b.locTotal - a.locTotal);

  for (const { locLabel, schools } of sortedLocs) {
    schoolRows.push({ type: "header", label: locLabel });
    const sortedSchools = [...schools.values()]
      .map(({ label, act1ids, act2ids }) =>
        [label, act1ids.size, act2ids.size, act1ids.size + act2ids.size])
      .sort((a, b) => b[3] - a[3]);
    for (const s of sortedSchools) schoolRows.push({ type: "data", data: s });
  }

  const maxSumRows = Math.max(schoolRows.length, citySummary.length, countrySummary.length, 0);

  const totalAct1Unique = new Set(act1Rows.map((r) => r["National ID"])).size;
  const totalAct2Unique = new Set(act2Rows.map((r) => r["National ID"])).size;
  const totalUnique     = totalAct1Unique + totalAct2Unique; // student in both = 2

  // ---- Grade Status counts (unique students) ----
  // A student appears once per ACT2 subject and can be in both sheets, so
  // dedupe by National ID first. grade_status is a per-student attribute and
  // is identical across all of that student's rows.
  const normGrade = (v) => (v || "").toString().trim();
  const gradeByStudent = new Map();
  const collectGrade = (rows) => {
    for (const r of rows) {
      const id = r["National ID"];
      if (id === null || id === undefined || id === "") continue;
      if (!gradeByStudent.has(id)) {
        gradeByStudent.set(id, normGrade(r["Grade Status"]) || "Unspecified");
      }
    }
  };
  collectGrade(act1Rows);
  collectGrade(act2Rows);

  const gradeCounts = new Map();
  for (const g of gradeByStudent.values()) {
    gradeCounts.set(g, (gradeCounts.get(g) || 0) + 1);
  }

  // Known statuses first in a fixed order, then any others alphabetically.
  const GRADE_ORDER = [
    "is enrolled in grade 11",
    "is enrolled in grade 12",
    "was enrolled in grade 12",
  ];
  const gradeRows = [
    ...GRADE_ORDER.filter((g) => gradeCounts.has(g)).map((g) => [g, gradeCounts.get(g)]),
    ...[...gradeCounts.keys()]
      .filter((g) => !GRADE_ORDER.includes(g))
      .sort()
      .map((g) => [g, gradeCounts.get(g)]),
  ];
  const gradeTotal = [...gradeCounts.values()].reduce((s, n) => s + n, 0);

  // Headline counts the report is asked to surface. Matched case-insensitively
  // so a differently-cased stored value is still counted.
  const countGradeLike = (needle) => {
    let n = 0;
    for (const g of gradeByStudent.values()) {
      if (g.toLowerCase() === needle) n++;
    }
    return n;
  };
  const grade11Count = countGradeLike("is enrolled in grade 11");
  const grade12Count = countGradeLike("is enrolled in grade 12");

  // ---- workbook ----
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  // ---- shared style helpers ----
  const styleMainHeader = (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleAct1Header = (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1A5276" } };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleSumHeader = (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2E6DA4" } };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleDataCell = (cell, bgArgb) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    cell.font = { size: 11, name: "Calibri" };
    cell.border = {
      top:    { style: "thin", color: { argb: "FFD0D7E5" } },
      left:   { style: "thin", color: { argb: "FFD0D7E5" } },
      bottom: { style: "thin", color: { argb: "FFD0D7E5" } },
      right:  { style: "thin", color: { argb: "FFD0D7E5" } },
    };
  };

  // helper: add a styled info row (merged across N cols)
  const addInfoRow = (sheet, text, cols, bgArgb, fontOpts, height = 20) => {
    const r = sheet.addRow([text]);
    sheet.mergeCells(`A${r.number}:${String.fromCharCode(64 + cols)}${r.number}`);
    r.height = height;
    r.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    r.getCell(1).font = { name: "Calibri", size: 11, ...fontOpts };
    r.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    return r;
  };

  // ================================================================
  // SHEET 1 — Summary  (13 columns)
  // Layout: A=School(1), B=ACT1(2), C=ACT2(3), D=spacer(4),
  //         E=City/Country(5), F=ACT1(6), G=ACT2(7), H=Total(8), I=spacer(9),
  //         J=Country(10), K=ACT1(11), L=ACT2(12), M=Total(13)
  // ================================================================
  const sumSheet = workbook.addWorksheet("Summary");
  [32, 14, 14, 4, 32, 14, 14, 14, 4, 26, 14, 14, 14].forEach((w, i) => {
    sumSheet.getColumn(i + 1).width = w;
  });

  addInfoRow(sumSheet, "ACT 1 & ACT 2 Top Achievers Report", 13, "FF1E3A5F",
    { bold: true, color: { argb: "FFFFFFFF" }, size: 16 }, 36);
  addInfoRow(sumSheet, `Authentication Date Range:   ${fmtInputDate(dateFrom)}  →  ${fmtInputDate(dateTo)}`,
    13, "FFD6E4F7", { italic: true, color: { argb: "FF1E3A5F" } }, 22);
  addInfoRow(sumSheet, `Grades Range:   ${minScore}  →  ${maxScore}`,
    13, "FFD6E4F7", { italic: true, color: { argb: "FF1E3A5F" } }, 22);
  addInfoRow(sumSheet,
    `Total Top Achievers: ${totalUnique} Students   |   ACT 1: ${totalAct1Unique}   |   ACT 2: ${totalAct2Unique}`,
    13, "FFEAF0FB", { bold: true, color: { argb: "FF1E3A5F" } }, 20);
  addInfoRow(sumSheet,
    `Grade 11: ${grade11Count} Students   |   Grade 12: ${grade12Count} Students`,
    13, "FFFFF3CD", { bold: true, color: { argb: "FF7D4E00" } }, 20);
  sumSheet.addRow([]); // spacer

  // Table headers row
  const sHdrRow = sumSheet.addRow([
    "School Name", "ACT 1", "ACT 2", "",
    "City, Country", "ACT 1", "ACT 2", "Total", "",
    "Country", "ACT 1", "ACT 2", "Total",
  ]);
  sHdrRow.height = 26;
  [1, 2, 3, 5, 6, 7, 8, 10, 11, 12, 13].forEach((c) => styleSumHeader(sHdrRow.getCell(c)));

  // Summary data rows
  let schoolDataIdx = 0; // alternating color counter for school data rows only
  for (let i = 0; i < maxSumRows; i++) {
    const sr = sumSheet.addRow([]);
    const rowBg = i % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";

    // ---- School column (cols 1-3): grouped by location ----
    const schoolRow = schoolRows[i];
    if (schoolRow) {
      if (schoolRow.type === "header") {
        // Location group header — spans all 3 school columns
        sr.height = 22;
        sr.getCell(1).value = schoolRow.label;
        sumSheet.mergeCells(`A${sr.number}:C${sr.number}`);
        sr.getCell(1).fill   = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2E6DA4" } };
        sr.getCell(1).font   = { bold: true, color: { argb: "FFFFFFFF" }, size: 11, name: "Calibri" };
        sr.getCell(1).alignment = { vertical: "middle", horizontal: "left", indent: 1 };
        sr.getCell(1).border = {
          top: { style: "thin" }, left: { style: "thin" },
          bottom: { style: "thin" }, right: { style: "thin" },
        };
      } else {
        const bg = schoolDataIdx % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
        schoolDataIdx++;
        sr.height = 20;
        sr.getCell(1).value = schoolRow.data[0];
        sr.getCell(2).value = schoolRow.data[1];
        sr.getCell(3).value = schoolRow.data[2];
        styleDataCell(sr.getCell(1), bg);
        styleDataCell(sr.getCell(2), bg);
        styleDataCell(sr.getCell(3), bg);
        sr.getCell(1).alignment = { vertical: "middle", horizontal: "left", indent: 2 };
        sr.getCell(2).alignment = { vertical: "middle", horizontal: "center" };
        sr.getCell(3).alignment = { vertical: "middle", horizontal: "center" };
      }
    }

    // ---- City/Country + Country columns ----
    const fillCols = (data, labelCol, act1Col, act2Col, totalCol) => {
      if (!data) return;
      sr.getCell(labelCol).value = data[0];
      sr.getCell(act1Col).value  = data[1];
      sr.getCell(act2Col).value  = data[2];
      styleDataCell(sr.getCell(labelCol), rowBg);
      styleDataCell(sr.getCell(act1Col),  rowBg);
      styleDataCell(sr.getCell(act2Col),  rowBg);
      sr.getCell(labelCol).alignment = { vertical: "middle", horizontal: "left" };
      sr.getCell(act1Col).alignment  = { vertical: "middle", horizontal: "center" };
      sr.getCell(act2Col).alignment  = { vertical: "middle", horizontal: "center" };
      if (totalCol) {
        sr.getCell(totalCol).value = data[3];
        styleDataCell(sr.getCell(totalCol), rowBg);
        sr.getCell(totalCol).font = { bold: true, size: 11, name: "Calibri" };
        sr.getCell(totalCol).alignment = { vertical: "middle", horizontal: "center" };
      }
    };

    fillCols(citySummary[i],    5, 6, 7, 8);
    fillCols(countrySummary[i], 10, 11, 12, 13);
  }

  // ---- Grade Status summary (unique students per grade status) ----
  // Label spans A:I, the count spans J:M so it lines up with the Country
  // table's Total column above it.
  const styleGradeTotalCell = (cell, value, isLabel = false) => {
    cell.value = value;
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
    cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: isLabel ? "left" : "center" };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  };

  sumSheet.addRow([]);
  const gsTitle = sumSheet.addRow(["Grade Status Summary (unique students)"]);
  sumSheet.mergeCells(`A${gsTitle.number}:M${gsTitle.number}`);
  gsTitle.height = 24;
  gsTitle.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
  gsTitle.getCell(1).font = { bold: true, size: 13, name: "Calibri", color: { argb: "FFFFFFFF" } };
  gsTitle.getCell(1).alignment = { vertical: "middle", horizontal: "center" };

  const gsHdr = sumSheet.addRow([]);
  sumSheet.mergeCells(`A${gsHdr.number}:I${gsHdr.number}`);
  sumSheet.mergeCells(`J${gsHdr.number}:M${gsHdr.number}`);
  gsHdr.height = 22;
  styleSumHeader(gsHdr.getCell(1));
  gsHdr.getCell(1).value = "Grade Status";
  gsHdr.getCell(1).alignment = { vertical: "middle", horizontal: "left", indent: 1 };
  styleSumHeader(gsHdr.getCell(10));
  gsHdr.getCell(10).value = "Students";

  gradeRows.forEach(([label, count], i) => {
    const gr = sumSheet.addRow([]);
    const rowBg = i % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
    sumSheet.mergeCells(`A${gr.number}:I${gr.number}`);
    sumSheet.mergeCells(`J${gr.number}:M${gr.number}`);
    gr.height = 20;
    gr.getCell(1).value = label;
    gr.getCell(10).value = count;
    styleDataCell(gr.getCell(1), rowBg);
    styleDataCell(gr.getCell(10), rowBg);
    gr.getCell(1).alignment = { vertical: "middle", horizontal: "left", indent: 1 };
    gr.getCell(10).alignment = { vertical: "middle", horizontal: "center" };
    gr.getCell(10).font = { bold: true, size: 11, name: "Calibri" };
  });

  const gsTot = sumSheet.addRow([]);
  sumSheet.mergeCells(`A${gsTot.number}:I${gsTot.number}`);
  sumSheet.mergeCells(`J${gsTot.number}:M${gsTot.number}`);
  gsTot.height = 22;
  styleGradeTotalCell(gsTot.getCell(1), "TOTAL", true);
  styleGradeTotalCell(gsTot.getCell(10), gradeTotal);

  sumSheet.views = [];

  // ================================================================
  // SHEET 2 — ACT 2 Top Achievers
  // The server returns exactly one row per student, with all three
  // subject/score slots as their own columns (act2_exam is 1:1 with
  // students). A subject/score pair the server left blank means that
  // particular score wasn't inside the requested grade range.
  // ================================================================
  const act2Sheet = workbook.addWorksheet("ACT2 Top Achievers");
  [20, 30, 18, 20, 22, 10, 22, 10, 22, 10, 22, 35, 20, 20].forEach((w, i) => {
    act2Sheet.getColumn(i + 1).width = w;
  });

  const act2Hdr = act2Sheet.addRow([
    "National ID", "Full Name", "Phone Number", "Event Location",
    "Subject 1", "Score 1", "Subject 2", "Score 2", "Subject 3", "Score 3",
    "Authentication Date", "School Name", "School City", "Grade Status",
  ]);
  act2Hdr.height = 28;
  act2Hdr.eachCell((cell) => styleMainHeader(cell));

  act2Rows.forEach((record, index) => {
    const dr = act2Sheet.addRow([
      record["National ID"],
      record["Full Name"],
      record["Phone Number"],
      record["Event Location"],
      record["Subject 1"],
      record["Score 1"],
      record["Subject 2"],
      record["Score 2"],
      record["Subject 3"],
      record["Score 3"],
      fmtDate(record["Authentication Date"]),
      toTitle(record["School Name"]),
      toTitle(record["School City"]),
      normGrade(record["Grade Status"]),
    ]);
    dr.height = 22;
    const bg = index % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
    dr.eachCell({ includeEmpty: true }, (cell) => {
      styleDataCell(cell, bg);
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    });
  });

  act2Sheet.views = [{ state: "frozen", ySplit: 1 }];

  // ================================================================
  // SHEET 3 — ACT 1 Top Achievers  (no Subject column)
  // ================================================================
  const act1Sheet = workbook.addWorksheet("ACT1 Top Achievers");
  [20, 30, 18, 20, 10, 22, 35, 20, 20].forEach((w, i) => {
    act1Sheet.getColumn(i + 1).width = w;
  });

  const act1Hdr = act1Sheet.addRow([
    "National ID", "Full Name", "Phone Number", "Event Location", "Score",
    "Authentication Date", "School Name", "School City", "Grade Status",
  ]);
  act1Hdr.height = 28;
  act1Hdr.eachCell((cell) => styleAct1Header(cell));

  act1Rows.forEach((record, index) => {
    const dr = act1Sheet.addRow([
      record["National ID"],
      record["Full Name"],
      record["Phone Number"],
      record["Event Location"],
      record["Score"],
      fmtDate(record["Authentication Date"]),
      toTitle(record["School Name"]),
      toTitle(record["School City"]),
      normGrade(record["Grade Status"]),
    ]);
    dr.height = 22;
    const bg = index % 2 === 0 ? "FFE8F5E9" : "FFFFFFFF"; // soft green alternating for ACT1
    dr.eachCell({ includeEmpty: true }, (cell) => {
      styleDataCell(cell, bg);
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    });
  });

  act1Sheet.views = [{ state: "frozen", ySplit: 1 }];

  // ================================================================
  // SHEET 4 — Schools Ranking (flat, sorted by total top achievers desc)
  // ================================================================
  const rankSheet = workbook.addWorksheet("Schools Ranking");
  [40, 25, 22, 14, 14, 14, 60].forEach((w, i) => {
    rankSheet.getColumn(i + 1).width = w;
  });

  const rankHdr = rankSheet.addRow([
    "School Name", "School City", "Country", "ACT 1", "ACT 2", "Total", "Merged From",
  ]);
  rankHdr.height = 28;
  rankHdr.eachCell((cell) => styleMainHeader(cell));

  // One row per school after merging name variants — the choices made in the
  // Merge Schools modal, or the automatic rules in constants/schoolNameGroups.js.
  // Export only: student data is untouched. Students are counted once per
  // school even if listed under two variants.
  const mergedNameOf = (raw) => {
    if (schoolMerge) return schoolMerge[schoolKey(raw || "Unknown")] || raw;
    return canonicalSchoolName(raw);
  };
  const rankBySchool = new Map();
  const addToRanking = (row, bucket) => {
    const original = toTitle(row["School Name"]) || "Unknown";
    const label = toTitle(mergedNameOf(row["School Name"])) || "Unknown";
    const key = normKey(label);
    if (!rankBySchool.has(key)) {
      rankBySchool.set(key, {
        label, cities: new Set(), countries: new Set(), names: new Set(),
        act1ids: new Set(), act2ids: new Set(),
        // National ID → best score in that exam (for the School Ranking Grades sheet)
        act1Best: new Map(), act2Best: new Map(),
        // "act1|id" / "act2|id" → student details (School Ranking Grades - Students sheet)
        students: new Map(),
      });
    }
    const entry = rankBySchool.get(key);
    const city = toTitle(row["School City"]);
    const country = toTitle(row["Country"]);
    if (city) entry.cities.add(city);
    if (country) entry.countries.add(country);
    entry.names.add(original);
    entry[bucket].add(row["National ID"]);

    // ACT 1 has one score; ACT 2 keeps the highest qualifying subject score.
    const scores = (bucket === "act1ids"
      ? [row["Score"]]
      : [row["Score 1"], row["Score 2"], row["Score 3"]])
      .map((v) => Math.round(Number(v)))
      .filter((n) => Number.isFinite(n) && n >= minScore && n <= maxScore);
    if (scores.length) {
      const best = entry[bucket === "act1ids" ? "act1Best" : "act2Best"];
      const id = row["National ID"];
      const bestScore = Math.max(best.get(id) ?? 0, ...scores);
      best.set(id, bestScore);

      const isAct1 = bucket === "act1ids";
      const subjects = isAct1
        ? ""
        : [1, 2, 3]
            .filter((n) => row[`Subject ${n}`] && row[`Score ${n}`] !== null && row[`Score ${n}`] !== undefined)
            .map((n) => `${row[`Subject ${n}`]}: ${row[`Score ${n}`]}`)
            .join(", ");
      const studentKey = `${isAct1 ? "act1" : "act2"}|${id}`;
      const prev = entry.students.get(studentKey);
      entry.students.set(studentKey, {
        id,
        name: toTitle(row["Full Name"]),
        exam: isAct1 ? "ACT 1" : "ACT 2",
        score: bestScore,
        subjects: [prev?.subjects, subjects].filter(Boolean).join(", "),
        phone: row["Phone Number"] || "",
        gradeStatus: row["Grade Status"] || "",
        authDate: fmtDate(row["Authentication Date"]),
        originalSchool: original,
      });
    }
  };
  act1Rows.forEach((r) => addToRanking(r, "act1ids"));
  act2Rows.forEach((r) => addToRanking(r, "act2ids"));

  const schoolRanking = [...rankBySchool.values()]
    .map(({ label, cities, countries, names, act1ids, act2ids }) => [
      label,
      [...cities].join(" / "),
      [...countries].join(" / "),
      act1ids.size,
      act2ids.size,
      act1ids.size + act2ids.size,
      names.size > 1 || !names.has(label) ? [...names].sort().join("\n") : "",
    ])
    .sort((a, b) => b[5] - a[5] || a[0].localeCompare(b[0]));

  schoolRanking.forEach((entry, index) => {
    const dr = rankSheet.addRow(entry);
    // Grow the row so every merged name in "Merged From" is visible.
    dr.height = Math.max(22, (entry[6] ? entry[6].split("\n").length : 1) * 15 + 6);
    const bg = index % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
    dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
      styleDataCell(cell, bg);
      cell.alignment = {
        vertical: "middle",
        horizontal: colNum === 1 || colNum === 7 ? "left" : "center",
        wrapText: true,
      };
      if (colNum === 6) cell.font = { bold: true, size: 11, name: "Calibri" };
      if (colNum === 7) cell.font = { size: 10, name: "Calibri", color: { argb: "FF555555" } };
    });
  });

  rankSheet.views = [{ state: "frozen", ySplit: 1 }];

  // ================================================================
  // SHEET 5 — School Ranking Grades (same merged schools as Schools Ranking)
  // One column per score in the selected range. Each student counts once per
  // exam at their best score in it (ACT 1 score / highest ACT 2 subject), so
  // Total matches the Schools Ranking Total. Ranked by the most top scores:
  // most 36s first, then 35s, and so on.
  // ================================================================
  const gradeSheet = workbook.addWorksheet("School Ranking Grades");
  const grades = [];
  for (let g = minScore; g <= maxScore; g++) grades.push(g);
  const GRADE_COLS = 4 + grades.length + 1; // Rank, School, City, Country, grades…, Total
  [8, 40, 25, 22, ...grades.map(() => 10), 12].forEach((w, i) => {
    gradeSheet.getColumn(i + 1).width = w;
  });

  const gradeHdr = gradeSheet.addRow([
    "Rank", "School Name", "School City", "Country",
    ...grades.map((g) => `Score ${g}`), "Total",
  ]);
  gradeHdr.height = 28;
  gradeHdr.eachCell((cell) => styleMainHeader(cell));

  const schoolGradeRows = [...rankBySchool.values()]
    .map(({ label, cities, countries, act1Best, act2Best, students }) => {
      const counts = grades.map(() => 0);
      for (const best of [act1Best, act2Best]) {
        for (const score of best.values()) counts[score - minScore] += 1;
      }
      return {
        label,
        city: [...cities].join(" / "),
        country: [...countries].join(" / "),
        counts,
        total: counts.reduce((a, b) => a + b, 0),
        students: [...students.values()],
      };
    })
    .filter((r) => r.total > 0)
    .sort((a, b) => {
      for (let i = grades.length - 1; i >= 0; i--) {
        if (b.counts[i] !== a.counts[i]) return b.counts[i] - a.counts[i];
      }
      return b.total - a.total || a.label.localeCompare(b.label);
    });

  schoolGradeRows.forEach((r, index) => {
    const dr = gradeSheet.addRow([index + 1, r.label, r.city, r.country, ...r.counts, r.total]);
    dr.height = 22;
    const bg = index % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
    dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
      styleDataCell(cell, bg);
      cell.alignment = {
        vertical: "middle",
        horizontal: colNum === 2 ? "left" : "center",
        wrapText: true,
      };
      // Blank out zero counts so the scores a school actually has stand out.
      if (colNum > 4 && colNum < GRADE_COLS && cell.value === 0) cell.value = "";
      if (colNum === GRADE_COLS) cell.font = { bold: true, size: 11, name: "Calibri" };
    });
  });

  // Totals row
  const gradeTotals = grades.map((_, i) => schoolGradeRows.reduce((sum, r) => sum + r.counts[i], 0));
  const gtRow = gradeSheet.addRow([
    "", "TOTAL", "", "", ...gradeTotals, gradeTotals.reduce((a, b) => a + b, 0),
  ]);
  gtRow.height = 24;
  gtRow.eachCell({ includeEmpty: true }, (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
    cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  });

  gradeSheet.views = [{ state: "frozen", ySplit: 1, xSplit: 2 }];

  // ================================================================
  // SHEET 6 — School Ranking Grades - Students
  // Same schools, order and counting as School Ranking Grades; under each
  // school, its students sorted by best score (a student in both exams is
  // listed once per exam, matching the counts).
  // ================================================================
  const gsSheet = workbook.addWorksheet("School Grades - Students");
  const GS_WIDTHS = [6, 20, 32, 10, 12, 40, 18, 22, 18, 40];
  const GS_COLS = GS_WIDTHS.length;
  GS_WIDTHS.forEach((w, i) => { gsSheet.getColumn(i + 1).width = w; });

  const gsHdrRow = gsSheet.addRow([
    "#", "National ID", "Full Name", "Exam", "Best Score", "Subjects / Scores",
    "Phone", "Grade Status", "Authentication Date", "School Name (as registered)",
  ]);
  gsHdrRow.height = 28;
  gsHdrRow.eachCell((cell) => styleMainHeader(cell));

  schoolGradeRows.forEach((school, schoolIdx) => {
    // School header: rank, name, location, count per score, total
    const location = [school.city, school.country].filter(Boolean).join(", ");
    const scoreSummary = grades
      .map((g, i) => (school.counts[i] ? `${g}: ${school.counts[i]}` : null))
      .filter(Boolean)
      .join("   ·   ");
    const head = gsSheet.addRow([
      `#${schoolIdx + 1}   ${school.label}${location ? `  —  ${location}` : ""}` +
      `      |      ${scoreSummary}      |      Total: ${school.total}`,
    ]);
    gsSheet.mergeCells(head.number, 1, head.number, GS_COLS);
    head.height = 26;
    const hc = head.getCell(1);
    hc.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2E75B6" } };
    hc.font = { bold: true, size: 12, name: "Calibri", color: { argb: "FFFFFFFF" } };
    hc.alignment = { vertical: "middle", horizontal: "left", indent: 1 };

    const students = [...school.students].sort(
      (a, b) => b.score - a.score || a.exam.localeCompare(b.exam) || a.name.localeCompare(b.name)
    );
    students.forEach((st, i) => {
      const dr = gsSheet.addRow([
        i + 1, st.id, st.name, st.exam, st.score, st.subjects,
        st.phone, st.gradeStatus, st.authDate,
        st.originalSchool !== school.label ? st.originalSchool : "",
      ]);
      dr.height = 20;
      const bg = i % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
      dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
        styleDataCell(cell, bg);
        cell.alignment = {
          vertical: "middle",
          horizontal: colNum === 3 || colNum === 6 || colNum === 10 ? "left" : "center",
          wrapText: true,
        };
        if (colNum === 5) cell.font = { bold: true, size: 11, name: "Calibri" };
      });
    });
    gsSheet.addRow([]);
  });

  gsSheet.views = [{ state: "frozen", ySplit: 1 }];

  // ---- save ----
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Top_Achievers_${minScore}-${maxScore}_${dateFrom}_to_${dateTo}.xlsx`);
}

// ================================================================
// Top Achievers Guests
//   Sheet 1 "Guests by Student" — one row per student, guests across columns
//   Sheet 2 "All Guests"        — one row per guest (flat list)
// Data is re-fetched so the sheet always reflects what is saved on the server,
// never a half-typed row still sitting in the page's inputs.
// ================================================================
const MAX_GUEST_COLUMNS = 9;

export async function excelTopAchieversGuests() {
  const res = await getTopAchieversGuests();
  if (!res || res.status !== 200) {
    alert("Failed to fetch Top Achievers guests. Please try again.");
    return;
  }

  const students = res.data?.data || [];

  const guestsOf = (s) =>
    (Array.isArray(s.guests) ? s.guests : []).filter(
      (n) => n !== null && n !== undefined && String(n).trim() !== ""
    );

  const totalGuests = students.reduce((sum, s) => sum + guestsOf(s).length, 0);
  const studentsWithGuests = students.filter((s) => guestsOf(s).length > 0).length;

  const cairoCount = students.filter((s) => s.event_location === "Cairo").length;
  const alexandriaCount = students.filter((s) => s.event_location === "Alexandria").length;
  const notSetLocationCount = students.length - cairoCount - alexandriaCount;
  const locationSummary =
    `Cairo: ${cairoCount}   |   Alexandria: ${alexandriaCount}   |   Not Set: ${notSetLocationCount}`;

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const styleMainHeader = (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleDataCell = (cell, bgArgb) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    cell.font = { size: 11, name: "Calibri" };
    cell.border = {
      top:    { style: "thin", color: { argb: "FFD0D7E5" } },
      left:   { style: "thin", color: { argb: "FFD0D7E5" } },
      bottom: { style: "thin", color: { argb: "FFD0D7E5" } },
      right:  { style: "thin", color: { argb: "FFD0D7E5" } },
    };
  };
  const addInfoRow = (sheet, text, cols, bgArgb, fontOpts, height = 20) => {
    const r = sheet.addRow([text]);
    sheet.mergeCells(r.number, 1, r.number, cols);
    r.height = height;
    r.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    r.getCell(1).font = { name: "Calibri", size: 11, ...fontOpts };
    r.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    return r;
  };

  // ---- Sheet 1: one row per student, Guest 1..9 across the columns ----
  const byStudent = workbook.addWorksheet("Guests by Student");
  const BY_STUDENT_COLS = 9 + MAX_GUEST_COLUMNS;
  [22, 32, 20, 18, 18, 14, 30, 18, 14, ...Array(MAX_GUEST_COLUMNS).fill(26)].forEach((w, i) => {
    byStudent.getColumn(i + 1).width = w;
  });

  addInfoRow(byStudent, "Top Achievers Guests", BY_STUDENT_COLS, "FF1E3A5F",
    { bold: true, color: { argb: "FFFFFFFF" }, size: 16 }, 34);
  addInfoRow(byStudent,
    `Students: ${students.length}   |   Students With Guests: ${studentsWithGuests}   |   Total Guests: ${totalGuests}`,
    BY_STUDENT_COLS, "FFEAF0FB", { bold: true, color: { argb: "FF1E3A5F" } }, 22);
  addInfoRow(byStudent, locationSummary,
    BY_STUDENT_COLS, "FFEAF0FB", { bold: true, color: { argb: "FF1E3A5F" } }, 22);
  byStudent.addRow([]);

  const byStudentHdr = byStudent.addRow([
    "National ID", "Full Name", "Phone", "School City", "Country",
    "ACT 1 Grade", "ACT 2 Grade", "Event Location", "Guests Count",
    ...Array.from({ length: MAX_GUEST_COLUMNS }, (_, i) => `Guest ${i + 1}`),
  ]);
  byStudentHdr.height = 26;
  byStudentHdr.eachCell((cell) => styleMainHeader(cell));
  const byStudentHdrRow = byStudentHdr.number;

  students.forEach((s, index) => {
    const guests = guestsOf(s);
    const padded = Array.from({ length: MAX_GUEST_COLUMNS }, (_, i) => guests[i] || "");
    const dr = byStudent.addRow([
      s.student_id,
      s.full_name,
      s.phone,
      s.school_city || "",
      s.school_country || "",
      s.act1_grade ?? "",
      s.act2_grade || "",
      s.event_location || "Not Set",
      guests.length,
      ...padded,
    ]);
    dr.height = 20;
    const bg = index % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
    dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
      styleDataCell(cell, bg);
      cell.alignment = {
        vertical: "middle",
        horizontal: colNum === 2 ? "left" : "center",
        wrapText: true,
      };
    });
    dr.getCell(9).font = { bold: true, size: 11, name: "Calibri" };
  });

  byStudent.views = [{
    state: "frozen",
    ySplit: byStudentHdrRow,
    topLeftCell: `A${byStudentHdrRow + 1}`,
    activeCell: `A${byStudentHdrRow + 1}`,
  }];

  // ---- Sheet 2: flat list, one row per guest ----
  const allGuests = workbook.addWorksheet("All Guests");
  const ALL_GUESTS_COLS = 10;
  [22, 32, 20, 18, 18, 14, 30, 18, 12, 32].forEach((w, i) => {
    allGuests.getColumn(i + 1).width = w;
  });

  addInfoRow(allGuests, "All Guests", ALL_GUESTS_COLS, "FF1E3A5F",
    { bold: true, color: { argb: "FFFFFFFF" }, size: 16 }, 34);
  addInfoRow(allGuests, `Total Guests: ${totalGuests}`,
    ALL_GUESTS_COLS, "FFEAF0FB", { bold: true, color: { argb: "FF1E3A5F" } }, 22);
  addInfoRow(allGuests, locationSummary,
    ALL_GUESTS_COLS, "FFEAF0FB", { bold: true, color: { argb: "FF1E3A5F" } }, 22);
  allGuests.addRow([]);

  const allGuestsHdr = allGuests.addRow([
    "National ID", "Student Name", "Phone", "School City", "Country",
    "ACT 1 Grade", "ACT 2 Grade", "Event Location", "Guest No", "Guest Name",
  ]);
  allGuestsHdr.height = 26;
  allGuestsHdr.eachCell((cell) => styleMainHeader(cell));
  const allGuestsHdrRow = allGuestsHdr.number;

  const flatGuests = students.flatMap((s) =>
    guestsOf(s).map((name, i) => [
      s.student_id, s.full_name, s.phone, s.school_city || "", s.school_country || "",
      s.act1_grade ?? "", s.act2_grade || "", s.event_location || "Not Set", i + 1, name,
    ])
  );

  flatGuests.forEach((entry, index) => {
    const dr = allGuests.addRow(entry);
    dr.height = 20;
    const bg = index % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
    dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
      styleDataCell(cell, bg);
      cell.alignment = {
        vertical: "middle",
        horizontal: colNum === 2 || colNum === 10 ? "left" : "center",
        wrapText: true,
      };
    });
  });

  if (totalGuests === 0) {
    const emptyRow = allGuests.addRow(["No guests recorded yet."]);
    allGuests.mergeCells(emptyRow.number, 1, emptyRow.number, ALL_GUESTS_COLS);
    emptyRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    emptyRow.getCell(1).font = {
      italic: true, size: 11, name: "Calibri", color: { argb: "FF888888" },
    };
  }

  allGuests.views = [{
    state: "frozen",
    ySplit: allGuestsHdrRow,
    topLeftCell: `A${allGuestsHdrRow + 1}`,
    activeCell: `A${allGuestsHdrRow + 1}`,
  }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const today = new Date().toISOString().slice(0, 10);
  saveAs(blob, `Top_Achievers_Guests_${today}.xlsx`);
}

// ================================================================
// All Grades Report  — same as ACT Top Achievers but:
//   • all score grades (no 30-36 filter)
//   • Summary: City/Country + Country only (no Schools table)
//   • No Schools Ranking sheet
// ================================================================
export async function excelAllGradesReport(dateFrom, dateTo, dateType = "auth") {
  const [resAct2, resAct1, resActual] = await Promise.all([
    exportAct2AllGradesReport(dateFrom, dateTo, dateType),
    exportAct1AllGradesReport(dateFrom, dateTo, dateType),
    getCountryActualCounts(),
  ]);

  if (!resAct2 || resAct2.status !== 200) {
    alert("Failed to fetch ACT 2 data. Please try again.");
    return;
  }
  if (!resAct1 || resAct1.status !== 200) {
    alert("Failed to fetch ACT 1 data. Please try again.");
    return;
  }

  const act2Rows = resAct2.data.data;
  const act1Rows = resAct1.data.data;

  // Actual (manually entered) target counts per country, keyed by normalized country name.
  // Used to compute Actual / % columns in the Country summary table.
  const actualByCountry = new Map();
  if (resActual && resActual.status === 200 && Array.isArray(resActual.data.data)) {
    for (const r of resActual.data.data) {
      const key = (r.country || "").trim().toLowerCase();
      if (!key) continue;
      actualByCountry.set(key, {
        act1: Number(r.act1_actual) || 0,
        act2: Number(r.act2_actual) || 0,
      });
    }
  }

  const fmtDate = (val) => {
    if (!val) return "";
    const s = val instanceof Date ? val.toISOString().slice(0, 10) : String(val).slice(0, 10);
    const [y, m, d] = s.split("-").map(Number);
    if (!y || !m || !d) return String(val);
    return new Date(y, m - 1, d).toLocaleDateString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
    });
  };
  const fmtInputDate = (yyyymmdd) => {
    if (!yyyymmdd) return "";
    const [y, m, d] = yyyymmdd.split("-").map(Number);
    return new Date(y, m - 1, d).toLocaleDateString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
    });
  };
  const normKey = (s) => (s || "").trim().replace(/\s+/g, " ").toLowerCase();
  const toTitle = (s) =>
    (s || "")
      .trim()
      .replace(/\s+/g, " ")
      .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());

  // ---- summary map: per-country aggregation ----
  const byCountry = new Map();

  const addToMap = (row, examType) => {
    const id      = row["National ID"];
    const country = toTitle(row["Country"]);
    const key     = normKey(country || "Unknown");
    const label   = country || "Unknown";
    const bucket  = examType === "act1" ? "act1ids" : "act2ids";
    if (!byCountry.has(key)) byCountry.set(key, { label, act1ids: new Set(), act2ids: new Set() });
    byCountry.get(key)[bucket].add(id);
  };

  act1Rows.forEach((r) => addToMap(r, "act1"));
  act2Rows.forEach((r) => addToMap(r, "act2"));

  // Country summary columns:
  //   [label, act1, act1Actual, act1Pct, act2, act2Actual, act2Pct, total, actualTotal, totalPct]
  const pct = (count, actual) =>
    actual > 0 ? Math.round((count / actual) * 10000) / 100 : 0;

  const countrySummary = [...byCountry.values()]
    .map(({ label, act1ids, act2ids }) => {
      const act1Count   = act1ids.size;
      const act2Count   = act2ids.size;
      const total       = new Set([...act1ids, ...act2ids]).size;
      const actual      = actualByCountry.get(label.toLowerCase()) || { act1: 0, act2: 0 };
      const actualTotal = actual.act1 + actual.act2;
      return [
        label,
        act1Count, actual.act1, pct(act1Count, actual.act1),
        act2Count, actual.act2, pct(act2Count, actual.act2),
        total, actualTotal, pct(total, actualTotal),
      ];
    })
    .sort((a, b) => b[7] - a[7]);

  const act1IdSet = new Set(act1Rows.map((r) => r["National ID"]));
  const act2IdSet = new Set(act2Rows.map((r) => r["National ID"]));
  const totalAct1Unique = act1IdSet.size;
  const totalAct2Unique = act2IdSet.size;
  const trueUniqueTotal = new Set([...act1IdSet, ...act2IdSet]).size;
  const inBothCount = totalAct1Unique + totalAct2Unique - trueUniqueTotal; // |A ∩ B|

  // ---- workbook ----
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  // ---- style helpers ----
  const styleMainHeader = (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleAct1Header = (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1A5276" } };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleSumHeader = (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2E6DA4" } };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleDataCell = (cell, bgArgb) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    cell.font = { size: 11, name: "Calibri" };
    cell.border = {
      top:    { style: "thin", color: { argb: "FFD0D7E5" } },
      left:   { style: "thin", color: { argb: "FFD0D7E5" } },
      bottom: { style: "thin", color: { argb: "FFD0D7E5" } },
      right:  { style: "thin", color: { argb: "FFD0D7E5" } },
    };
  };
  const addInfoRow = (sheet, text, cols, bgArgb, fontOpts, height = 20) => {
    const r = sheet.addRow([text]);
    sheet.mergeCells(`A${r.number}:${String.fromCharCode(64 + cols)}${r.number}`);
    r.height = height;
    r.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    r.getCell(1).font = { name: "Calibri", size: 11, ...fontOpts };
    r.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    return r;
  };

  // ================================================================
  // SHEET 1 — Summary  (10 columns, Country only)
  // A=Country(1), B=ACT1(2), C=ACT1 Actual(3), D=ACT1 %(4),
  // E=ACT2(5), F=ACT2 Actual(6), G=ACT2 %(7),
  // H=Total(8), I=Actual Total(9), J=Total %(10)
  // ================================================================
  const TOTAL_COLS = 10;
  const sumSheet = workbook.addWorksheet("Summary");
  [26, 12, 14, 12, 12, 14, 12, 14, 14, 12].forEach((w, i) => {
    sumSheet.getColumn(i + 1).width = w;
  });

  addInfoRow(sumSheet, "ACT 1 & ACT 2 All Grades Report", TOTAL_COLS, "FF1E3A5F",
    { bold: true, color: { argb: "FFFFFFFF" }, size: 16 }, 36);
  addInfoRow(sumSheet,
    `Authentication Date Range:   ${fmtInputDate(dateFrom)}  →  ${fmtInputDate(dateTo)}`,
    TOTAL_COLS, "FFD6E4F7", { italic: true, color: { argb: "FF1E3A5F" } }, 22);

  // Student count breakdown row: 3 cells across the 10-col width
  //   A:C  ACT 1 Sheet count   |   D:G  ACT 2 Sheet count   |   H:J  In Both
  const countRow = sumSheet.addRow([]);
  sumSheet.mergeCells(`A${countRow.number}:C${countRow.number}`);
  sumSheet.mergeCells(`D${countRow.number}:G${countRow.number}`);
  sumSheet.mergeCells(`H${countRow.number}:J${countRow.number}`);
  countRow.height = 20;
  const styleCountCell = (colNum, text, bgArgb, fontArgb = "FF1E3A5F") => {
    const c = countRow.getCell(colNum);
    c.value = text;
    c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    c.font = { bold: true, size: 11, name: "Calibri", color: { argb: fontArgb } };
    c.alignment = { vertical: "middle", horizontal: "center" };
    c.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
  };
  styleCountCell(1, `ACT 1 Sheet: ${totalAct1Unique} students`, "FFE8F5E9");
  styleCountCell(4, `ACT 2 Sheet: ${totalAct2Unique} students`, "FFEAF0FB");
  styleCountCell(8, `In Both: ${inBothCount}`, "FFFFF3CD", "FF7D4E00");

  // True unique total row
  const uniqueRow = sumSheet.addRow([
    `Unique Total: ${trueUniqueTotal}  |  ACT 1 Only: ${totalAct1Unique - inBothCount}  |  In Both Sheets: ${inBothCount}  |  ACT 2 Only: ${totalAct2Unique - inBothCount}`,
  ]);
  sumSheet.mergeCells(`A${uniqueRow.number}:${String.fromCharCode(64 + TOTAL_COLS)}${uniqueRow.number}`);
  uniqueRow.height = 22;
  uniqueRow.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
  uniqueRow.getCell(1).font = { bold: true, size: 12, name: "Calibri", color: { argb: "FFFFFFFF" } };
  uniqueRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
  uniqueRow.getCell(1).border = { top: { style: "medium" }, left: { style: "thin" }, bottom: { style: "medium" }, right: { style: "thin" } };

  sumSheet.addRow([]);

  const sHdrRow = sumSheet.addRow([
    "Country",
    "ACT 1", "ACT 1 Actual", "ACT 1 %",
    "ACT 2", "ACT 2 Actual", "ACT 2 %",
    "Total", "Actual Total", "Total %",
  ]);
  sHdrRow.height = 26;
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].forEach((c) => styleSumHeader(sHdrRow.getCell(c)));

  const fmtPct = (v) => (v > 0 ? `${v.toFixed(2)}%` : "—");

  // Country: [label, act1, act1Actual, act1Pct, act2, act2Actual, act2Pct, total, actualTotal, totalPct]
  countrySummary.forEach((data, i) => {
    const sr = sumSheet.addRow([]);
    const rowBg = i % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";

    sr.getCell(1).value  = data[0];
    sr.getCell(2).value  = data[1];
    sr.getCell(3).value  = data[2];
    sr.getCell(4).value  = fmtPct(data[3]);
    sr.getCell(5).value  = data[4];
    sr.getCell(6).value  = data[5];
    sr.getCell(7).value  = fmtPct(data[6]);
    sr.getCell(8).value  = data[7];
    sr.getCell(9).value  = data[8];
    sr.getCell(10).value = fmtPct(data[9]);
    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].forEach((c) => styleDataCell(sr.getCell(c), rowBg));
    sr.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
    [2, 3, 4, 5, 6, 7, 8, 9, 10].forEach((c) => {
      sr.getCell(c).alignment = { vertical: "middle", horizontal: "center" };
    });
    sr.getCell(8).font = { bold: true, size: 11, name: "Calibri" };
    sr.getCell(9).font = { bold: true, size: 11, name: "Calibri" };
    // Subtle highlight for the % cells
    sr.getCell(4).font  = { bold: true, size: 11, name: "Calibri", color: { argb: "FF1A5276" } };
    sr.getCell(7).font  = { bold: true, size: 11, name: "Calibri", color: { argb: "FF1A5276" } };
    sr.getCell(10).font = { bold: true, size: 11, name: "Calibri", color: { argb: "FF1A5276" } };
  });

  // ---- Totals row ----
  const cntryTotAct1        = countrySummary.reduce((s, r) => s + r[1], 0);
  const cntryTotAct1Actual  = countrySummary.reduce((s, r) => s + r[2], 0);
  const cntryTotAct2        = countrySummary.reduce((s, r) => s + r[4], 0);
  const cntryTotAct2Actual  = countrySummary.reduce((s, r) => s + r[5], 0);
  const cntryTotAll         = countrySummary.reduce((s, r) => s + r[7], 0);
  const cntryTotActualTotal = cntryTotAct1Actual + cntryTotAct2Actual;
  const cntryAct1Pct = cntryTotAct1Actual > 0
    ? (cntryTotAct1 / cntryTotAct1Actual) * 100 : 0;
  const cntryAct2Pct = cntryTotAct2Actual > 0
    ? (cntryTotAct2 / cntryTotAct2Actual) * 100 : 0;
  const cntryTotalPct = cntryTotActualTotal > 0
    ? (cntryTotAll / cntryTotActualTotal) * 100 : 0;

  const totRow = sumSheet.addRow([]);
  totRow.height = 24;
  const styleTotalCell = (cell, value, isLabel = false) => {
    cell.value = value;
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
    cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: isLabel ? "left" : "center" };
    cell.border = { top: { style: "medium" }, left: { style: "thin" }, bottom: { style: "medium" }, right: { style: "thin" } };
  };
  styleTotalCell(totRow.getCell(1), `TOTAL (${countrySummary.length} countries)`, true);
  styleTotalCell(totRow.getCell(2),  cntryTotAct1);
  styleTotalCell(totRow.getCell(3),  cntryTotAct1Actual);
  styleTotalCell(totRow.getCell(4),  cntryAct1Pct > 0 ? `${cntryAct1Pct.toFixed(2)}%` : "—");
  styleTotalCell(totRow.getCell(5),  cntryTotAct2);
  styleTotalCell(totRow.getCell(6),  cntryTotAct2Actual);
  styleTotalCell(totRow.getCell(7),  cntryAct2Pct > 0 ? `${cntryAct2Pct.toFixed(2)}%` : "—");
  styleTotalCell(totRow.getCell(8),  cntryTotAll);
  styleTotalCell(totRow.getCell(9),  cntryTotActualTotal);
  styleTotalCell(totRow.getCell(10), cntryTotalPct > 0 ? `${cntryTotalPct.toFixed(2)}%` : "—");

  // ---- Grade Status summary (unique students per grade status) ----
  // A student appears once per ACT2 subject and can be in both sheets, so
  // dedupe by National ID before counting. grade_status is a per-student
  // attribute, identical across all of that student's rows.
  const gradeByStudent = new Map();
  const collectGrade = (rows) => {
    for (const r of rows) {
      const id = r["National ID"];
      if (id === null || id === undefined || id === "") continue;
      if (!gradeByStudent.has(id)) {
        const g = (r["Grade Status"] || "").toString().trim();
        gradeByStudent.set(id, g || "Unspecified");
      }
    }
  };
  collectGrade(act1Rows);
  collectGrade(act2Rows);

  const gradeCounts = new Map();
  for (const g of gradeByStudent.values()) {
    gradeCounts.set(g, (gradeCounts.get(g) || 0) + 1);
  }

  // Known statuses first in a fixed order, then any others alphabetically.
  const GRADE_ORDER = [
    "is enrolled in grade 11",
    "is enrolled in grade 12",
    "was enrolled in grade 12",
  ];
  const gradeRows = [
    ...GRADE_ORDER.filter((g) => gradeCounts.has(g)).map((g) => [g, gradeCounts.get(g)]),
    ...[...gradeCounts.keys()]
      .filter((g) => !GRADE_ORDER.includes(g))
      .sort()
      .map((g) => [g, gradeCounts.get(g)]),
  ];
  const gradeTotal = [...gradeCounts.values()].reduce((s, n) => s + n, 0);

  sumSheet.addRow([]);
  const gsTitle = sumSheet.addRow(["Grade Status Summary (unique students)"]);
  sumSheet.mergeCells(`A${gsTitle.number}:J${gsTitle.number}`);
  gsTitle.height = 24;
  gsTitle.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
  gsTitle.getCell(1).font = { bold: true, size: 13, name: "Calibri", color: { argb: "FFFFFFFF" } };
  gsTitle.getCell(1).alignment = { vertical: "middle", horizontal: "center" };

  const gsHdr = sumSheet.addRow([]);
  sumSheet.mergeCells(`A${gsHdr.number}:G${gsHdr.number}`);
  sumSheet.mergeCells(`H${gsHdr.number}:J${gsHdr.number}`);
  gsHdr.height = 22;
  styleSumHeader(gsHdr.getCell(1));
  gsHdr.getCell(1).value = "Grade Status";
  gsHdr.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
  styleSumHeader(gsHdr.getCell(8));
  gsHdr.getCell(8).value = "Students";

  gradeRows.forEach(([label, count], i) => {
    const gr = sumSheet.addRow([]);
    const rowBg = i % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
    sumSheet.mergeCells(`A${gr.number}:G${gr.number}`);
    sumSheet.mergeCells(`H${gr.number}:J${gr.number}`);
    gr.getCell(1).value = label;
    gr.getCell(8).value = count;
    styleDataCell(gr.getCell(1), rowBg);
    styleDataCell(gr.getCell(8), rowBg);
    gr.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
    gr.getCell(8).alignment = { vertical: "middle", horizontal: "center" };
    gr.getCell(8).font = { bold: true, size: 11, name: "Calibri" };
  });

  const gsTot = sumSheet.addRow([]);
  sumSheet.mergeCells(`A${gsTot.number}:G${gsTot.number}`);
  sumSheet.mergeCells(`H${gsTot.number}:J${gsTot.number}`);
  gsTot.height = 22;
  styleTotalCell(gsTot.getCell(1), "TOTAL", true);
  styleTotalCell(gsTot.getCell(8), gradeTotal);

  sumSheet.views = [];

  // Groups scores into 3-point ranges (1-3, 4-6, ..., 34-36) and returns a
  // descending list of [rangeLabel, count]. Ranges with zero students are
  // omitted so the block stays compact.
  // Skips rows with no numeric Score so blanks don't pollute the distribution.
  const RANGE_SIZE = 3;
  const buildGradeDistribution = (rows) => {
    const counts = new Map(); // key = range start
    for (const r of rows) {
      const raw = r["Score"];
      if (raw === null || raw === undefined || raw === "") continue;
      const score = Number(raw);
      if (!Number.isFinite(score)) continue;
      const start = Math.floor((score - 1) / RANGE_SIZE) * RANGE_SIZE + 1;
      counts.set(start, (counts.get(start) || 0) + 1);
    }
    return [...counts.entries()]
      .sort(([a], [b]) => b - a)
      .map(([start, count]) => [`${start}-${start + RANGE_SIZE - 1}`, count]);
  };

  // Renders a Grade Distribution block at the top of an ACT sheet as a
  // vertical 2-column table: col 1 = Score Range, col 2 = Count. Scores are
  // grouped into 3-point ranges so the block stays compact.
  const addGradeDistribution = (sheet, dist, numCols, headerBgArgb) => {
    // Title banner spans the full data-table width so the block is visually
    // anchored to the data table below it.
    addInfoRow(sheet, "Grade Distribution", numCols, headerBgArgb,
      { bold: true, color: { argb: "FFFFFFFF" }, size: 12 }, 22);

    // Column headers — only cols 1 and 2 are used
    const hdrRow = sheet.addRow(["Score Range", "Count"]);
    hdrRow.height = 20;
    [1, 2].forEach((c) => {
      const cell = hdrRow.getCell(c);
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: headerBgArgb } };
      cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11, name: "Calibri" };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = {
        top: { style: "thin" }, left: { style: "thin" },
        bottom: { style: "thin" }, right: { style: "thin" },
      };
    });

    // One row per range that has at least one student
    dist.forEach(([label, count], idx) => {
      const r = sheet.addRow([label, count]);
      r.height = 18;
      const bg = idx % 2 === 0 ? "FFFFF3CD" : "FFFFFFFF";
      [1, 2].forEach((c) => {
        const cell = r.getCell(c);
        styleDataCell(cell, bg);
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FF7D4E00" } };
      });
    });

    // Total footer
    const total = dist.reduce((s, [, c]) => s + c, 0);
    const totalRow = sheet.addRow(["Total", total]);
    totalRow.height = 20;
    [1, 2].forEach((c) => {
      const cell = totalRow.getCell(c);
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
      cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11, name: "Calibri" };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = {
        top: { style: "medium" }, left: { style: "thin" },
        bottom: { style: "medium" }, right: { style: "thin" },
      };
    });

    sheet.addRow([]); // spacer before the data table
  };

  // ================================================================
  // SHEET 2 — ACT 2 All Grades
  // ================================================================
  const act2Sheet = workbook.addWorksheet("ACT2 All Grades");
  const ACT2_COLS = 10;
  [20, 30, 18, 10, 30, 22, 22, 35, 20, 20].forEach((w, i) => {
    act2Sheet.getColumn(i + 1).width = w;
  });

  addGradeDistribution(act2Sheet, buildGradeDistribution(act2Rows), ACT2_COLS, "FF1E3A5F");

  const act2Hdr = act2Sheet.addRow([
    "National ID", "Full Name", "Phone Number", "Score", "Subject",
    "Authentication Date", "ACT 2 Trial Date", "School Name", "School City", "Country",
  ]);
  act2Hdr.height = 28;
  act2Hdr.eachCell((cell) => styleMainHeader(cell));
  const act2HdrRowNum = act2Hdr.number;

  act2Rows.forEach((record, index) => {
    const dr = act2Sheet.addRow([
      record["National ID"],
      record["Full Name"],
      record["Phone Number"],
      record["Score"],
      record["Subject"],
      fmtDate(record["Authentication Date"]),
      fmtDate(record["ACT 2 Trial Date"]),
      toTitle(record["School Name"]),
      toTitle(record["School City"]),
      toTitle(record["Country"]),
    ]);
    dr.height = 22;
    const bg = index % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
    dr.eachCell({ includeEmpty: true }, (cell) => {
      styleDataCell(cell, bg);
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    });
  });

  act2Sheet.views = [{
    state: "frozen",
    ySplit: act2HdrRowNum,
    topLeftCell: `A${act2HdrRowNum + 1}`,
    activeCell: `A${act2HdrRowNum + 1}`,
  }];

  // ================================================================
  // SHEET 3 — ACT 1 All Grades
  // ================================================================
  const act1Sheet = workbook.addWorksheet("ACT1 All Grades");
  const ACT1_COLS = 9;
  [20, 30, 18, 10, 22, 22, 35, 20, 20].forEach((w, i) => {
    act1Sheet.getColumn(i + 1).width = w;
  });

  addGradeDistribution(act1Sheet, buildGradeDistribution(act1Rows), ACT1_COLS, "FF1A5276");

  const act1Hdr = act1Sheet.addRow([
    "National ID", "Full Name", "Phone Number", "Score",
    "Authentication Date", "ACT 1 Trial Date", "School Name", "School City", "Country",
  ]);
  act1Hdr.height = 28;
  act1Hdr.eachCell((cell) => styleAct1Header(cell));
  const act1HdrRowNum = act1Hdr.number;

  act1Rows.forEach((record, index) => {
    const dr = act1Sheet.addRow([
      record["National ID"],
      record["Full Name"],
      record["Phone Number"],
      record["Score"],
      fmtDate(record["Authentication Date"]),
      fmtDate(record["ACT 1 Trial Date"]),
      toTitle(record["School Name"]),
      toTitle(record["School City"]),
      toTitle(record["Country"]),
    ]);
    dr.height = 22;
    const bg = index % 2 === 0 ? "FFE8F5E9" : "FFFFFFFF";
    dr.eachCell({ includeEmpty: true }, (cell) => {
      styleDataCell(cell, bg);
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    });
  });

  act1Sheet.views = [{
    state: "frozen",
    ySplit: act1HdrRowNum,
    topLeftCell: `A${act1HdrRowNum + 1}`,
    activeCell: `A${act1HdrRowNum + 1}`,
  }];

  // ================================================================
  // SHEET 4 — Grade 11 Students (unique students enrolled in grade 11)
  // A student can appear across the ACT1 and ACT2 rows (and once per ACT2
  // subject), so dedupe by National ID; the Exams column records which
  // sheet(s) each student came from.
  // ================================================================
  const isGrade11 = (r) =>
    (r["Grade Status"] || "").toString().toLowerCase().includes("grade 11");

  const grade11ById = new Map();
  const collectGrade11 = (rows, exam) => {
    for (const r of rows) {
      if (!isGrade11(r)) continue;
      const id = r["National ID"];
      if (id === null || id === undefined || id === "") continue;
      if (!grade11ById.has(id)) {
        grade11ById.set(id, {
          id,
          name: r["Full Name"],
          phone: r["Phone Number"],
          school: r["School Name"],
          city: r["School City"],
          country: r["Country"],
          exams: new Set(),
        });
      }
      grade11ById.get(id).exams.add(exam);
    }
  };
  collectGrade11(act1Rows, "ACT1");
  collectGrade11(act2Rows, "ACT2");

  const grade11List = [...grade11ById.values()].sort((a, b) =>
    (a.name || "").localeCompare(b.name || "")
  );

  const g11Sheet = workbook.addWorksheet("Grade 11 Students");
  const G11_COLS = 8;
  [20, 30, 18, 35, 20, 20, 18, 14].forEach((w, i) => {
    g11Sheet.getColumn(i + 1).width = w;
  });

  addInfoRow(g11Sheet, "Grade 11 Students", G11_COLS, "FF1E3A5F",
    { bold: true, color: { argb: "FFFFFFFF" }, size: 16 }, 30);
  addInfoRow(g11Sheet, `Total Grade 11 Students: ${grade11List.length}`,
    G11_COLS, "FFD6E4F7", { bold: true, italic: true, color: { argb: "FF1E3A5F" } }, 22);

  const g11Hdr = g11Sheet.addRow([
    "National ID", "Full Name", "Phone Number", "School Name",
    "School City", "Country", "Grade Status", "Exams",
  ]);
  g11Hdr.height = 28;
  g11Hdr.eachCell((cell) => styleMainHeader(cell));
  const g11HdrRowNum = g11Hdr.number;

  if (grade11List.length === 0) {
    const emptyRow = g11Sheet.addRow(["No grade 11 students in this range."]);
    g11Sheet.mergeCells(`A${emptyRow.number}:${String.fromCharCode(64 + G11_COLS)}${emptyRow.number}`);
    emptyRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    emptyRow.getCell(1).font = { italic: true, size: 11, name: "Calibri", color: { argb: "FF888888" } };
  } else {
    grade11List.forEach((s, index) => {
      const dr = g11Sheet.addRow([
        s.id,
        s.name,
        s.phone,
        toTitle(s.school),
        toTitle(s.city),
        toTitle(s.country),
        "Grade 11",
        [...s.exams].sort().join(", "),
      ]);
      dr.height = 22;
      const bg = index % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
      dr.eachCell({ includeEmpty: true }, (cell) => {
        styleDataCell(cell, bg);
        cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      });
    });
  }

  g11Sheet.views = [{
    state: "frozen",
    ySplit: g11HdrRowNum,
    topLeftCell: `A${g11HdrRowNum + 1}`,
    activeCell: `A${g11HdrRowNum + 1}`,
  }];

  // ---- save ----
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `All_Grades_Report_${dateFrom}_to_${dateTo}.xlsx`);
}

// ================================================================
// GRADE 11 REPORT
// Grade 11 students split by category group:
//   • Inside  (individual, individualA, foreign, foreignA, foreignA_UAE,
//              foreignB_UAE, foreignUsd):
//       two sheets — "Inside ACT 1" and "Inside ACT 2" — each listing
//       National ID, Full Name, Phone, Category and that exam's score,
//       for students whose score is 25–36.
//   • Outside (outside, outsideA): one sheet with both ACT 1 Score and
//       ACT 2 Score columns; a score below 25 (or above 36) is left blank,
//       and a student appears only if at least one of their scores is 25–36.
// ================================================================
export async function excelGrade11Report(dateFrom, dateTo, dateType = "auth") {
  const [resAct1, resAct2] = await Promise.all([
    exportAct1AllGradesReport(dateFrom, dateTo, dateType),
    exportAct2AllGradesReport(dateFrom, dateTo, dateType),
  ]);
  if (!resAct1 || resAct1.status !== 200) {
    alert("Failed to fetch ACT 1 data. Please try again.");
    return;
  }
  if (!resAct2 || resAct2.status !== 200) {
    alert("Failed to fetch ACT 2 data. Please try again.");
    return;
  }

  const act1Rows = resAct1.data.data;
  const act2Rows = resAct2.data.data;

  const INSIDE_CATS = ["individual", "individualA", "foreign", "foreignA", "foreignA_UAE", "foreignB_UAE", "foreignUsd"];
  const OUTSIDE_CATS = ["outside", "outsideA"];
  const isGrade11 = (r) =>
    (r["Grade Status"] || "").toString().toLowerCase().includes("grade 11");
  const inRange = (v) => v !== null && Number.isFinite(v) && v >= 25 && v <= 36;

  // Per-student aggregate (grade 11 only). ACT2 has one row per subject, so
  // its score is the best (max) across the student's subjects; ACT1 already
  // arrives as one row per student.
  const byId = new Map();
  const addScores = (rows, key) => {
    for (const r of rows) {
      if (!isGrade11(r)) continue;
      const id = r["National ID"];
      if (id === null || id === undefined || id === "") continue;
      if (!byId.has(id)) {
        byId.set(id, {
          id,
          name: r["Full Name"],
          phone: r["Phone Number"],
          category: (r["Category"] || "").toString().trim(),
          act1Score: null,
          act2Score: null,
        });
      }
      const e = byId.get(id);
      if (!e.category && r["Category"]) e.category = String(r["Category"]).trim();
      const sc = Number(r["Score"]);
      if (Number.isFinite(sc)) e[key] = e[key] === null ? sc : Math.max(e[key], sc);
    }
  };
  addScores(act1Rows, "act1Score");
  addScores(act2Rows, "act2Score");

  const students = [...byId.values()];
  const insideStudents = students.filter((s) => INSIDE_CATS.includes(s.category));
  const outsideStudents = students.filter((s) => OUTSIDE_CATS.includes(s.category));
  const byName = (a, b) => (a.name || "").localeCompare(b.name || "");

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const colLetter = (n) => String.fromCharCode(64 + n);
  const styleHeader = (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
  };
  const styleData = (cell, bg) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
    cell.font = { size: 11, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
  };

  const buildSheet = (name, title, headers, widths, rowsData, scoreCols) => {
    const sheet = workbook.addWorksheet(name);
    const numCols = headers.length;
    widths.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });

    const tRow = sheet.addRow([title]);
    sheet.mergeCells(`A${tRow.number}:${colLetter(numCols)}${tRow.number}`);
    tRow.height = 28;
    tRow.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
    tRow.getCell(1).font = { bold: true, color: { argb: "FFFFFFFF" }, size: 15, name: "Calibri" };
    tRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };

    const cRow = sheet.addRow([`Total Students: ${rowsData.length}`]);
    sheet.mergeCells(`A${cRow.number}:${colLetter(numCols)}${cRow.number}`);
    cRow.height = 20;
    cRow.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD6E4F7" } };
    cRow.getCell(1).font = { bold: true, italic: true, color: { argb: "FF1E3A5F" }, name: "Calibri" };
    cRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };

    const hRow = sheet.addRow(headers);
    hRow.height = 26;
    hRow.eachCell((cell) => styleHeader(cell));
    const hNum = hRow.number;

    if (rowsData.length === 0) {
      const eRow = sheet.addRow(["No grade 11 students match this criteria in this range."]);
      sheet.mergeCells(`A${eRow.number}:${colLetter(numCols)}${eRow.number}`);
      eRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
      eRow.getCell(1).font = { italic: true, size: 11, name: "Calibri", color: { argb: "FF888888" } };
    } else {
      rowsData.forEach((row, idx) => {
        const dr = sheet.addRow(row);
        dr.height = 20;
        const bg = idx % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
        dr.eachCell({ includeEmpty: true }, (cell) => styleData(cell, bg));
        (scoreCols || []).forEach((c) => {
          dr.getCell(c).font = { bold: true, size: 11, name: "Calibri", color: { argb: "FF1A5276" } };
        });
      });
    }

    sheet.views = [{ state: "frozen", ySplit: hNum, topLeftCell: `A${hNum + 1}`, activeCell: `A${hNum + 1}` }];
  };

  const fmtRangeDate = (yyyymmdd) => {
    if (!yyyymmdd) return "";
    const [y, m, d] = String(yyyymmdd).split("-").map(Number);
    if (!y || !m || !d) return String(yyyymmdd);
    return new Date(y, m - 1, d).toLocaleDateString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
    });
  };
  const rangeLabel = `${fmtRangeDate(dateFrom)}  →  ${fmtRangeDate(dateTo)}`;

  // ---- Inside ACT 1 ----
  const inside1 = insideStudents
    .filter((s) => inRange(s.act1Score))
    .sort(byName)
    .map((s) => [s.id, s.name, s.phone, s.category, s.act1Score]);
  buildSheet(
    "Inside ACT 1",
    `Grade 11 — Inside ACT 1 (Score 25–36)   |   ${rangeLabel}`,
    ["National ID", "Full Name", "Phone Number", "Category", "ACT 1 Score"],
    [20, 30, 18, 16, 12],
    inside1,
    [5]
  );

  // ---- Inside ACT 2 ----
  const inside2 = insideStudents
    .filter((s) => inRange(s.act2Score))
    .sort(byName)
    .map((s) => [s.id, s.name, s.phone, s.category, s.act2Score]);
  buildSheet(
    "Inside ACT 2",
    `Grade 11 — Inside ACT 2 (Score 25–36)   |   ${rangeLabel}`,
    ["National ID", "Full Name", "Phone Number", "Category", "ACT 2 Score"],
    [20, 30, 18, 16, 12],
    inside2,
    [5]
  );

  // ---- Outside (both exams in one sheet) ----
  const outside = outsideStudents
    .filter((s) => inRange(s.act1Score) || inRange(s.act2Score))
    .sort(byName)
    .map((s) => [
      s.id,
      s.name,
      s.phone,
      s.category,
      inRange(s.act1Score) ? s.act1Score : "",
      inRange(s.act2Score) ? s.act2Score : "",
    ]);
  buildSheet(
    "Outside",
    `Grade 11 — Outside (Score 25–36)   |   ${rangeLabel}`,
    ["National ID", "Full Name", "Phone Number", "Category", "ACT 1 Score", "ACT 2 Score"],
    [20, 30, 18, 16, 12, 12],
    outside,
    [5, 6]
  );

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Grade_11_Report_${dateFrom}_to_${dateTo}.xlsx`);
}

// ================================================================
// TRANSFER REPORTS — client-side only (data passed directly)
// ================================================================

const TRANSFER_DISPLAY_CAT = {
  "individual": "individualB",
  "foreign":    "foreignB",
  "outside":    "OutsideB",
};
const tfDisplayCat = (cat) => cat ? (TRANSFER_DISPLAY_CAT[cat] || cat) : "—";

const tfFmtDate = (val) => {
  if (!val) return "—";
  return new Date(val).toLocaleString("en-GB", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
};

const tfStyleHeader = (cell, argb = "FF1E3A5F") => {
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
  cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11, name: "Calibri" };
  cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
  cell.border = {
    top: { style: "thin" }, left: { style: "thin" },
    bottom: { style: "thin" }, right: { style: "thin" },
  };
};

const tfStyleData = (cell, bgArgb) => {
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
  cell.font = { size: 11, name: "Calibri" };
  cell.border = {
    top:    { style: "thin", color: { argb: "FFD0D7E5" } },
    left:   { style: "thin", color: { argb: "FFD0D7E5" } },
    bottom: { style: "thin", color: { argb: "FFD0D7E5" } },
    right:  { style: "thin", color: { argb: "FFD0D7E5" } },
  };
  cell.alignment = { vertical: "middle", horizontal: "left" };
};

const tfAddBanner = (sheet, text, numCols, bgArgb, fontArgb, bold, size, height) => {
  const r = sheet.addRow([text]);
  const endCol = String.fromCharCode(64 + numCols);
  sheet.mergeCells(`A${r.number}:${endCol}${r.number}`);
  r.height = height;
  r.getCell(1).value = text;
  r.getCell(1).fill  = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
  r.getCell(1).font  = { bold, size, name: "Calibri", color: { argb: fontArgb } };
  r.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
  return r;
};

// ── Report 1: Pending Transfers ───────────────────────────────────────────────
export async function exportPendingTransfers(rows) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Pending Transfers");
  const colDefs = [
    { header: "#",             width: 6  },
    { header: "National ID",   width: 22 },
    { header: "Student Phone", width: 18 },
    { header: "Father Phone",  width: 18 },
    { header: "Mother Phone",  width: 18 },
    { header: "Full Name",     width: 32 },
    { header: "Category",      width: 16 },
    { header: "University",    width: 22 },
    { header: "Match",         width: 20 },
    { header: "Submitted At",  width: 22 },
  ];
  const N = colDefs.length;
  colDefs.forEach((c, i) => { sheet.getColumn(i + 1).width = c.width; });

  // ── Banners ──
  tfAddBanner(sheet, "Pending Transfer Requests", N, "FF1E3A5F", "FFFFFFFF", true,  16, 36);
  tfAddBanner(sheet, `Generated: ${new Date().toLocaleString("en-GB")}`, N, "FFD6E4F7", "FF1E3A5F", false, 11, 20);
  tfAddBanner(sheet, `Total Pending Students: ${rows.length}`, N, "FFEAF0FB", "FF1E3A5F", true, 13, 24);
  sheet.addRow([]); // spacer

  // ── Column headers ──
  const hRow = sheet.addRow(colDefs.map((c) => c.header));
  hRow.height = 26;
  hRow.eachCell((cell) => tfStyleHeader(cell, "FF1E3A5F"));

  // ── Data rows ──
  const matchLabel = (m) =>
    m === "id" ? "Matched by ID" : m === "passport" ? "Matched by Passport" : "Not Found";

  rows.forEach((row, idx) => {
    const bg   = idx % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
    const dRow = sheet.addRow([
      idx + 1,
      row.national_id    || "—",
      row.student_phone  || "—",
      row.father_phone   || "—",
      row.mother_phone   || "—",
      row.full_name      || "—",
      tfDisplayCat(row.category),
      row.university     || "—",
      matchLabel(row.matched_by),
      tfFmtDate(row.submitted_at),
    ]);
    dRow.height = 20;
    dRow.eachCell((cell, colNum) => {
      tfStyleData(cell, bg);
      if (colNum === 1) cell.alignment = { vertical: "middle", horizontal: "center" };
    });
  });

  sheet.views = [{ state: "frozen", ySplit: 5 }];

  const buf = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
    `Pending_Transfers_${new Date().toISOString().slice(0, 10)}.xlsx`
  );
}

// ── Send Score Submissions (approver export) ────────────────────────────────
// Takes the rows already loaded on the Send Score Submissions page (already
// filtered to the chosen submitted-date range by the caller) — no separate
// fetch — and writes them out as-is, in the order shown on screen, with an
// amounts-by-currency summary (approved vs. not approved) at the top.
export async function excelScoreSubmissions(rows, dateFrom, dateTo) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Send Score Submissions");
  const colDefs = [
    { header: "Full Name",     width: 24 },
    { header: "National ID",   width: 22 },
    { header: "ACT ID",        width: 18 },
    { header: "Amount",        width: 14 },
    { header: "Currency",      width: 12 },
    { header: "Status",        width: 14 },
    { header: "Submitted By",  width: 20 },
    { header: "Submitted At",  width: 22 },
  ];
  const N = colDefs.length;
  colDefs.forEach((c, i) => { sheet.getColumn(i + 1).width = c.width; });

  const pendingCount = rows.filter((r) => r.status === "pending").length;
  const approvedCount = rows.filter((r) => r.status === "approved").length;

  // Amounts by currency, approved vs. not approved (pending + rejected).
  // The USD lines are only meaningful — and only shown — when a submission
  // actually used USD.
  const sumWhere = (currency, approved) =>
    rows
      .filter((r) => (r.currency || "EGP") === currency && (r.status === "approved") === approved)
      .reduce((s, r) => s + (Number(r.amount) || 0), 0);
  const hasUsd = rows.some((r) => (r.currency || "EGP") === "USD");
  const egpApproved = sumWhere("EGP", true);
  const egpNotApproved = sumWhere("EGP", false);
  const usdApproved = hasUsd ? sumWhere("USD", true) : null;
  const usdNotApproved = hasUsd ? sumWhere("USD", false) : null;

  const rangeLabel =
    dateFrom || dateTo
      ? `Submitted Date Range: ${dateFrom || "…"}  →  ${dateTo || "…"}`
      : "Submitted Date Range: All Dates";

  tfAddBanner(sheet, "Send Score Submissions", N, "FF1E3A5F", "FFFFFFFF", true, 16, 36);
  tfAddBanner(sheet, `Generated: ${new Date().toLocaleString("en-GB")}`, N, "FFD6E4F7", "FF1E3A5F", false, 11, 20);
  tfAddBanner(sheet, rangeLabel, N, "FFD6E4F7", "FF1E3A5F", false, 11, 20);
  tfAddBanner(
    sheet,
    `Total: ${rows.length}   |   Pending: ${pendingCount}   |   Approved: ${approvedCount}`,
    N, "FFEAF0FB", "FF1E3A5F", true, 13, 24
  );

  // ── Amounts summary (per currency, approved vs. not approved) ──
  const summaryTitle = sheet.addRow(["Amounts Summary"]);
  sheet.mergeCells(`A${summaryTitle.number}:${String.fromCharCode(64 + N)}${summaryTitle.number}`);
  summaryTitle.height = 24;
  summaryTitle.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1A5276" } };
  summaryTitle.getCell(1).font = { bold: true, color: { argb: "FFFFFFFF" }, size: 13, name: "Calibri" };
  summaryTitle.getCell(1).alignment = { vertical: "middle", horizontal: "center" };

  const addSummaryRow = (label, value, bgArgb) => {
    const r = sheet.addRow([]);
    sheet.mergeCells(`A${r.number}:${String.fromCharCode(64 + (N - 2))}${r.number}`);
    sheet.mergeCells(`${String.fromCharCode(64 + (N - 1))}${r.number}:${String.fromCharCode(64 + N)}${r.number}`);
    r.height = 20;
    r.getCell(1).value = label;
    r.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    r.getCell(1).font = { bold: true, size: 11, name: "Calibri", color: { argb: "FF1E3A5F" } };
    r.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
    r.getCell(N - 1).value = value;
    r.getCell(N - 1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    r.getCell(N - 1).font = { bold: true, size: 11, name: "Calibri", color: { argb: "FF1A5276" } };
    r.getCell(N - 1).alignment = { vertical: "middle", horizontal: "center" };
  };
  addSummaryRow("EGP — Approved", egpApproved.toFixed(2), "FFE8F5E9");
  addSummaryRow("EGP — Not Approved", egpNotApproved.toFixed(2), "FFFFFFFF");
  if (hasUsd) {
    addSummaryRow("USD — Approved", usdApproved.toFixed(2), "FFE8F5E9");
    addSummaryRow("USD — Not Approved", usdNotApproved.toFixed(2), "FFFFFFFF");
  }

  sheet.addRow([]);

  const hRow = sheet.addRow(colDefs.map((c) => c.header));
  hRow.height = 26;
  hRow.eachCell((cell) => tfStyleHeader(cell, "FF1E3A5F"));
  const hRowNum = hRow.number;

  const fmtDateTime = (val) => {
    if (!val) return "—";
    const d = new Date(String(val).replace(" ", "T"));
    return isNaN(d.getTime())
      ? String(val)
      : d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  };

  rows.forEach((row, idx) => {
    const bg = idx % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
    const dRow = sheet.addRow([
      row.full_name || "—",
      row.national_id || "—",
      row.act_id || "—",
      row.amount,
      row.currency || "EGP",
      row.status,
      row.submitted_by || "—",
      fmtDateTime(row.submitted_at),
    ]);
    dRow.height = 20;
    dRow.eachCell((cell) => tfStyleData(cell, bg));
  });

  sheet.views = [{ state: "frozen", ySplit: hRowNum }];

  const buf = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
    `Send_Score_Submissions_${new Date().toISOString().slice(0, 10)}.xlsx`
  );
}

// ── Report 2: Transferred Students ───────────────────────────────────────────
export async function exportTransferredStudents(rows) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Transferred Students");
  const colDefs = [
    { header: "#",               width: 6  },
    { header: "National ID",     width: 22 },
    { header: "Full Name",       width: 32 },
    { header: "New Category",    width: 16 },
    { header: "New University",  width: 20 },
    { header: "Submitted At",    width: 22 },
    { header: "Transferred At",  width: 22 },
    { header: "Transferred By",  width: 20 },
  ];
  const N = colDefs.length;
  colDefs.forEach((c, i) => { sheet.getColumn(i + 1).width = c.width; });

  // ── Banners ──
  tfAddBanner(sheet, "Transferred Students Report", N, "FF1A5C34", "FFFFFFFF", true,  16, 36);
  tfAddBanner(sheet, `Generated: ${new Date().toLocaleString("en-GB")}`, N, "FFD5F5E3", "FF1A5C34", false, 11, 20);
  tfAddBanner(sheet, `Total Transferred Students: ${rows.length}`, N, "FFEBF5EA", "FF1A5C34", true, 13, 24);
  sheet.addRow([]); // spacer

  // ── Column headers ──
  const hRow = sheet.addRow(colDefs.map((c) => c.header));
  hRow.height = 26;
  hRow.eachCell((cell) => tfStyleHeader(cell, "FF1A5C34"));

  // ── Data rows ──
  rows.forEach((row, idx) => {
    const bg   = idx % 2 === 0 ? "FFEBF5EA" : "FFFFFFFF";
    const dRow = sheet.addRow([
      idx + 1,
      row.national_id    || "—",
      row.full_name      || "—",
      row.category       || "—",
      row.university     || "—",
      tfFmtDate(row.submitted_at),
      tfFmtDate(row.transferred_at),
      row.transferred_by || "—",
    ]);
    dRow.height = 20;
    dRow.eachCell((cell, colNum) => {
      tfStyleData(cell, bg);
      if (colNum === 1) cell.alignment = { vertical: "middle", horizontal: "center" };
    });
  });

  sheet.views = [{ state: "frozen", ySplit: 5 }];

  const buf = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
    `Transferred_Students_${new Date().toISOString().slice(0, 10)}.xlsx`
  );
}

// ================================================================
// Universities Report — Public vs Private
//   • Private sheet:  individual, foreign, foreignB_UAE, outside, foreignUsd
//   • Public  sheet:  individualA, foreignA, foreignA_UAE, outsideA
//   • Summary sheet:  counts for each
// Filter: invoice_date in [from, to]. The "Another Invoice Date" column
// is only populated when another_invoice_date also falls within the range.
// ================================================================
const PRIVATE_CATS = new Set(["individual", "foreign", "foreignB_UAE", "outside", "foreignUsd"]);
const PUBLIC_CATS  = new Set(["individualA", "foreignA", "foreignA_UAE", "outsideA"]);
const DELIVERED_STATES = new Set(["done", "mohe", "mohe_validation"]);

export async function excelUniversitiesReport(dateFrom, dateTo) {
  const res = await exportUniversitiesReport(dateFrom, dateTo);
  if (!res || res.status !== 200) {
    alert("Failed to fetch Universities Report. Please try again.");
    return;
  }
  const rows = res.data.data || [];

  const fmtDate = (val) => {
    if (!val) return "";
    const s = val instanceof Date ? val.toISOString().slice(0, 10) : String(val).slice(0, 10);
    const [y, m, d] = s.split("-").map(Number);
    if (!y || !m || !d) return String(val);
    return new Date(y, m - 1, d).toLocaleDateString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
    });
  };
  const fmtInputDate = (yyyymmdd) => {
    if (!yyyymmdd) return "";
    const [y, m, d] = yyyymmdd.split("-").map(Number);
    return new Date(y, m - 1, d).toLocaleDateString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
    });
  };

  const byInvoiceDate = (a, b) => {
    const da = a["Invoice Date"] || "";
    const db = b["Invoice Date"] || "";
    return da < db ? -1 : da > db ? 1 : 0;
  };
  const privateRows = rows.filter((r) => PRIVATE_CATS.has(r["Category"])).sort(byInvoiceDate);
  const publicRows  = rows.filter((r) => PUBLIC_CATS.has(r["Category"])).sort(byInvoiceDate);

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const styleMainHeader = (cell, argb = "FF1E3A5F") => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleDataCell = (cell, bgArgb) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    cell.font = { size: 11, name: "Calibri" };
    cell.border = {
      top:    { style: "thin", color: { argb: "FFD0D7E5" } },
      left:   { style: "thin", color: { argb: "FFD0D7E5" } },
      bottom: { style: "thin", color: { argb: "FFD0D7E5" } },
      right:  { style: "thin", color: { argb: "FFD0D7E5" } },
    };
  };
  const addInfoRow = (sheet, text, cols, bgArgb, fontOpts, height = 20) => {
    const r = sheet.addRow([text]);
    sheet.mergeCells(`A${r.number}:${String.fromCharCode(64 + cols)}${r.number}`);
    r.height = height;
    r.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    r.getCell(1).font = { name: "Calibri", size: 11, ...fontOpts };
    r.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    return r;
  };

  // Count students per workflow state and return a sorted [state, count] list.
  const countByState = (dataRows) => {
    const m = new Map();
    for (const r of dataRows) {
      const k = r["State"] || "(none)";
      m.set(k, (m.get(k) || 0) + 1);
    }
    return [...m.entries()].sort((a, b) => b[1] - a[1]);
  };

  // Renders a "Students per State" summary block at the top of a detail sheet.
  // Uses cols 1-2 for State / Count so it sits cleanly above the data table.
  const addStateSummary = (sheet, dataRows, numCols, headerArgb) => {
    addInfoRow(sheet, "Students per State", numCols, headerArgb,
      { bold: true, color: { argb: "FFFFFFFF" }, size: 12 }, 22);

    const hdrRow = sheet.addRow(["State", "Count"]);
    hdrRow.height = 20;
    [1, 2].forEach((c) => {
      const cell = hdrRow.getCell(c);
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: headerArgb } };
      cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11, name: "Calibri" };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = {
        top: { style: "thin" }, left: { style: "thin" },
        bottom: { style: "thin" }, right: { style: "thin" },
      };
    });

    const byState = countByState(dataRows);
    byState.forEach(([state, count], idx) => {
      const r = sheet.addRow([state, count]);
      r.height = 18;
      const bg = idx % 2 === 0 ? "FFFFF3CD" : "FFFFFFFF";
      [1, 2].forEach((c) => {
        const cell = r.getCell(c);
        styleDataCell(cell, bg);
        cell.alignment = { vertical: "middle", horizontal: c === 1 ? "left" : "center" };
        cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FF7D4E00" } };
      });
    });

    const totalRow = sheet.addRow(["Total", dataRows.length]);
    totalRow.height = 20;
    [1, 2].forEach((c) => {
      const cell = totalRow.getCell(c);
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
      cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11, name: "Calibri" };
      cell.alignment = { vertical: "middle", horizontal: c === 1 ? "left" : "center" };
      cell.border = {
        top: { style: "medium" }, left: { style: "thin" },
        bottom: { style: "medium" }, right: { style: "thin" },
      };
    });

    sheet.addRow([]); // spacer
  };

  const buildDetailSheet = (sheet, dataRows, headerArgb, altRowArgb) => {
    const NUM_COLS = 7;
    [22, 32, 22, 18, 18, 22, 18].forEach((w, i) => { sheet.getColumn(i + 1).width = w; });

    addInfoRow(sheet, sheet.name, NUM_COLS, headerArgb,
      { bold: true, color: { argb: "FFFFFFFF" }, size: 16 }, 32);
    addInfoRow(sheet,
      `Invoice Date Range:   ${fmtInputDate(dateFrom)}  →  ${fmtInputDate(dateTo)}`,
      NUM_COLS, "FFD6E4F7", { italic: true, color: { argb: "FF1E3A5F" } }, 20);
    addInfoRow(sheet, `Total Students: ${dataRows.length}`,
      NUM_COLS, "FFEAF0FB", { bold: true, color: { argb: "FF1E3A5F" } }, 22);
    sheet.addRow([]);

    addStateSummary(sheet, dataRows, NUM_COLS, headerArgb);

    const hdr = sheet.addRow([
      "National ID", "Full Name", "State", "Category",
      "Invoice Date", "Another Invoice Date", "Delivery Status",
    ]);
    hdr.height = 26;
    hdr.eachCell((cell) => styleMainHeader(cell, headerArgb));

    dataRows.forEach((rec, idx) => {
      const isDelivered = DELIVERED_STATES.has(rec["State"]);
      const dr = sheet.addRow([
        rec["National ID"],
        rec["Full Name"],
        rec["State"] || "",
        rec["Category"] || "",
        fmtDate(rec["Invoice Date"]),
        fmtDate(rec["Another Invoice Date"]),
        isDelivered ? "Delivered" : "Not Delivered",
      ]);
      dr.height = 20;
      const bg = idx % 2 === 0 ? altRowArgb : "FFFFFFFF";
      dr.eachCell({ includeEmpty: true }, (cell) => {
        styleDataCell(cell, bg);
        cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      });
      const statusCell = dr.getCell(7);
      statusCell.font = {
        bold: true, size: 11, name: "Calibri",
        color: { argb: isDelivered ? "FF1A5C34" : "FFA94442" },
      };
    });

    sheet.views = [{ showGridLines: true }];
  };

  // Counts delivered vs not-delivered for a set of rows.
  // Delivered = state ∈ {done, mohe, mohe_validation}.
  const deliveryCounts = (dataRows) => {
    let delivered = 0;
    for (const r of dataRows) {
      if (DELIVERED_STATES.has(r["State"])) delivered++;
    }
    return { delivered, notDelivered: dataRows.length - delivered, total: dataRows.length };
  };

  // ---- Summary sheet ----
  const SUM_COLS = 5;
  const sumSheet = workbook.addWorksheet("Summary");
  [32, 18, 18, 18, 18].forEach((w, i) => { sumSheet.getColumn(i + 1).width = w; });

  addInfoRow(sumSheet, "Universities Report — Summary", SUM_COLS, "FF1E3A5F",
    { bold: true, color: { argb: "FFFFFFFF" }, size: 16 }, 32);
  addInfoRow(sumSheet,
    `Invoice Date Range:   ${fmtInputDate(dateFrom)}  →  ${fmtInputDate(dateTo)}`,
    SUM_COLS, "FFD6E4F7", { italic: true, color: { argb: "FF1E3A5F" } }, 22);
  sumSheet.addRow([]);

  // ── Student counts table ──
  addInfoRow(sumSheet, "Student Counts", SUM_COLS, "FF2E6DA4",
    { bold: true, color: { argb: "FFFFFFFF" }, size: 13 }, 24);

  const sHdr = sumSheet.addRow(["University Type", "Student Count", "", "", ""]);
  sHdr.height = 26;
  [1, 2].forEach((c) => styleMainHeader(sHdr.getCell(c), "FF2E6DA4"));

  const addSumRow = (label, count, bg) => {
    const r = sumSheet.addRow([label, count, "", "", ""]);
    r.height = 22;
    [1, 2].forEach((c) => {
      const cell = r.getCell(c);
      styleDataCell(cell, bg);
      cell.alignment = {
        vertical: "middle",
        horizontal: c === 1 ? "left" : "center",
      };
      if (c === 2) cell.font = { bold: true, size: 12, name: "Calibri" };
    });
  };
  addSumRow("Private Universities", privateRows.length, "FFEAF0FB");
  addSumRow("Public Universities",  publicRows.length,  "FFE8F5E9");

  const totRow = sumSheet.addRow(["TOTAL", privateRows.length + publicRows.length, "", "", ""]);
  totRow.height = 24;
  [1, 2].forEach((c) => {
    const cell = totRow.getCell(c);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E3A5F" } };
    cell.font = { bold: true, size: 12, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = {
      vertical: "middle",
      horizontal: c === 1 ? "left" : "center",
    };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  });

  sumSheet.addRow([]);

  // ── Delivery table ──
  // Delivered = state ∈ {done, mohe, mohe_validation}; everything else = not delivered.
  addInfoRow(sumSheet, "Delivery Status", SUM_COLS, "FF1A5C34",
    { bold: true, color: { argb: "FFFFFFFF" }, size: 13 }, 24);

  const dHdr = sumSheet.addRow([
    "University Type", "Delivered", "Not Delivered", "Total", "Delivered %",
  ]);
  dHdr.height = 26;
  [1, 2, 3, 4, 5].forEach((c) => styleMainHeader(dHdr.getCell(c), "FF1A5C34"));

  const addDeliveryRow = (label, rowsForBucket, bg) => {
    const { delivered, notDelivered, total } = deliveryCounts(rowsForBucket);
    const pct = total > 0 ? `${((delivered / total) * 100).toFixed(2)}%` : "—";
    const r = sumSheet.addRow([label, delivered, notDelivered, total, pct]);
    r.height = 22;
    [1, 2, 3, 4, 5].forEach((c) => {
      const cell = r.getCell(c);
      styleDataCell(cell, bg);
      cell.alignment = {
        vertical: "middle",
        horizontal: c === 1 ? "left" : "center",
      };
      if (c === 4) cell.font = { bold: true, size: 12, name: "Calibri" };
      if (c === 5) cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FF1A5C34" } };
    });
  };
  addDeliveryRow("Private Universities", privateRows, "FFEAF0FB");
  addDeliveryRow("Public Universities",  publicRows,  "FFE8F5E9");

  const allRows = [...privateRows, ...publicRows];
  const dTot = deliveryCounts(allRows);
  const dTotPct = dTot.total > 0 ? `${((dTot.delivered / dTot.total) * 100).toFixed(2)}%` : "—";
  const dTotRow = sumSheet.addRow([
    "TOTAL", dTot.delivered, dTot.notDelivered, dTot.total, dTotPct,
  ]);
  dTotRow.height = 24;
  [1, 2, 3, 4, 5].forEach((c) => {
    const cell = dTotRow.getCell(c);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1A5C34" } };
    cell.font = { bold: true, size: 12, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = {
      vertical: "middle",
      horizontal: c === 1 ? "left" : "center",
    };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  });

  // ---- Private + Public sheets ----
  const privateSheet = workbook.addWorksheet("Private Universities");
  buildDetailSheet(privateSheet, privateRows, "FF1E3A5F", "FFEAF0FB");

  const publicSheet  = workbook.addWorksheet("Public Universities");
  buildDetailSheet(publicSheet, publicRows, "FF1A5C34", "FFE8F5E9");

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Universities_Report_${dateFrom}_to_${dateTo}.xlsx`);
}

export async function excelAllInvoicesReport(dateFrom, dateTo) {
  const USD_CATS = ["outside", "outsideA", "foreignUsd"];
  const getCurrency = (cat) => USD_CATS.includes(cat) ? "USD" : "EGP";
  const getInvoiceAmount = (r) => {
    if (r.category === "outsideA") return Number(r.total_main) || 0;
    if (r.category === "outside" || r.category === "foreignUsd") {
      return Number(r.amount_outside) || 0;
    }
    return Number(r.total_main) || 0;
  };
  // Returns true if a YYYY-MM-DD date string falls within the selected range
  const isInRange = (dateStr) => !!dateStr && dateStr >= dateFrom && dateStr <= dateTo;

  const res = await exportAllInvoicesReport(dateFrom, dateTo);
  if (!res || res.status !== 200) {
    alert("Failed to fetch Invoice Report.");
    return;
  }
  const rows = res.data?.data || [];

  // Build summary per category — count main invoice only if invoice_date is in range,
  // count another invoice only if another_invoice_date is in range
  const summaryMap = {};
  for (const r of rows) {
    const cat = r.category || "unknown";
    if (!summaryMap[cat]) {
      summaryMap[cat] = {
        category: cat,
        currency: getCurrency(cat),
        invoiceCount: 0,
        invoiceTotal: 0,
        anotherCount: 0,
        anotherTotal: 0,
      };
    }
    if (isInRange(r.invoice_date)) {
      summaryMap[cat].invoiceCount += 1;
      summaryMap[cat].invoiceTotal += getInvoiceAmount(r);
    }
    if (isInRange(r.another_invoice_date)) {
      summaryMap[cat].anotherCount += 1;
      summaryMap[cat].anotherTotal += Number(r.another_total_main) || 0;
    }
  }
  const summaryRows = Object.values(summaryMap).sort((a, b) =>
    a.category.localeCompare(b.category)
  );

  // Build monthly summary — main invoices bucketed by invoice_date,
  // another invoices bucketed by their own another_invoice_date
  const MONTH_NAMES = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December",
  ];
  const monthMap = {};
  const getOrCreateMonth = (dateStr) => {
    const dt = new Date(dateStr);
    if (isNaN(dt)) return null;
    const key = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}`;
    const label = `${MONTH_NAMES[dt.getMonth()]} ${dt.getFullYear()}`;
    if (!monthMap[key]) {
      monthMap[key] = { key, label, invoiceCount: 0, egpTotal: 0, usdTotal: 0, anotherCount: 0, anotherTotal: 0 };
    }
    return monthMap[key];
  };
  for (const r of rows) {
    if (isInRange(r.invoice_date)) {
      const bucket = getOrCreateMonth(r.invoice_date);
      if (bucket) {
        bucket.invoiceCount += 1;
        const currency = getCurrency(r.category);
        const amount = getInvoiceAmount(r);
        if (currency === "USD") bucket.usdTotal += amount;
        else bucket.egpTotal += amount;
      }
    }
    if (isInRange(r.another_invoice_date)) {
      const bucket = getOrCreateMonth(r.another_invoice_date);
      if (bucket) {
        bucket.anotherCount += 1;
        bucket.anotherTotal += Number(r.another_total_main) || 0;
      }
    }
  }
  const monthlyRows = Object.values(monthMap).sort((a, b) => a.key.localeCompare(b.key));

  const DARK_BLUE  = "FF1F4E79";
  const MID_BLUE   = "FF2E75B6";
  const LIGHT_BLUE = "FFD6E4F0";
  const EVEN_ROW   = "FFF2F7FB";
  const GREEN_DARK = "FF1D6A38";
  const AMBER_DARK = "FF92400E";
  const AMBER_MID  = "FFB45309";
  const AMBER_ROW  = "FFFEF3C7";

  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString("en-GB");
  };
  const fmtMoney = (n) => (n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "AATC System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("All Invoices Report");
  const COL_WIDTHS = [5, 16, 28, 16, 14, 10, 16, 18, 18, 20, 18, 22];
  COL_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });
  const NUM_COLS = COL_WIDTHS.length;

  const styleHeader = (cell, argb) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, size: 12, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleData = (cell, bg) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
    cell.font = { size: 11, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const addMergedRow = (text, argb, height = 24, fontSize = 13) => {
    const row = sheet.addRow([text]);
    row.height = height;
    sheet.mergeCells(row.number, 1, row.number, NUM_COLS);
    const cell = row.getCell(1);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, size: fontSize, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
  };

  // Title
  addMergedRow("All Invoices Report", DARK_BLUE, 36, 18);
  addMergedRow(
    `Invoice Date Range:   ${dateFrom}  →  ${dateTo}`,
    LIGHT_BLUE, 22, 11
  );
  sheet.getRow(sheet.rowCount).getCell(1).font = {
    italic: true, size: 11, name: "Calibri", color: { argb: DARK_BLUE },
  };
  sheet.addRow([]);

  // ---- SUMMARY section ----
  addMergedRow("SUMMARY BY CATEGORY", MID_BLUE, 26, 13);

  const sumHdrLabels = ["Category", "Currency", "Invoice Count", "Invoice Total", "Another Invoice Count", "Another Invoice Total (EGP)"];
  const sumHdr = sheet.addRow(sumHdrLabels);
  sumHdr.height = 26;
  // Merge over NUM_COLS but we only have 6 summary cols — place them in first 6 cols
  sumHdr.eachCell((cell) => styleHeader(cell, MID_BLUE));

  summaryRows.forEach((sr, idx) => {
    const bg = idx % 2 === 0 ? EVEN_ROW : "FFFFFFFF";
    const r = sheet.addRow([
      sr.category,
      sr.currency,
      sr.invoiceCount,
      fmtMoney(sr.invoiceTotal),
      sr.anotherCount,
      fmtMoney(sr.anotherTotal),
    ]);
    r.height = 20;
    r.eachCell({ includeEmpty: true }, (cell) => styleData(cell, bg));
  });

  // Summary totals
  const totEgpSum = summaryRows
    .filter((s) => s.currency === "EGP")
    .reduce((a, b) => a + b.invoiceTotal, 0);
  const totUsdSum = summaryRows
    .filter((s) => s.currency === "USD")
    .reduce((a, b) => a + b.invoiceTotal, 0);
  const totAnotherSum = summaryRows.reduce((a, b) => a + b.anotherTotal, 0);

  const sumTotRow = sheet.addRow([
    "TOTAL", "",
    summaryRows.reduce((a, b) => a + b.invoiceCount, 0),
    `EGP: ${fmtMoney(totEgpSum)}  |  USD: ${fmtMoney(totUsdSum)}`,
    summaryRows.reduce((a, b) => a + b.anotherCount, 0),
    fmtMoney(totAnotherSum),
  ]);
  sumTotRow.height = 24;
  sumTotRow.eachCell({ includeEmpty: true }, (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: DARK_BLUE } };
    cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  });

  sheet.addRow([]);

  // ---- MONTHLY BREAKDOWN section ----
  addMergedRow("MONTHLY BREAKDOWN", AMBER_DARK, 26, 13);

  const monHdrLabels = [
    "Month", "Invoice Count", "EGP Amount", "USD Amount",
    "Another Invoice Count", "Another Amount (EGP)",
  ];
  const monHdr = sheet.addRow(monHdrLabels);
  monHdr.height = 26;
  monHdr.eachCell((cell) => styleHeader(cell, AMBER_MID));

  monthlyRows.forEach((m, idx) => {
    const bg = idx % 2 === 0 ? AMBER_ROW : "FFFFFFFF";
    const r = sheet.addRow([
      m.label,
      m.invoiceCount,
      fmtMoney(m.egpTotal),
      fmtMoney(m.usdTotal),
      m.anotherCount,
      fmtMoney(m.anotherTotal),
    ]);
    r.height = 20;
    r.eachCell({ includeEmpty: true }, (cell) => styleData(cell, bg));
  });

  // Monthly totals row
  const monTotRow = sheet.addRow([
    "TOTAL",
    monthlyRows.reduce((a, b) => a + b.invoiceCount, 0),
    fmtMoney(monthlyRows.reduce((a, b) => a + b.egpTotal, 0)),
    fmtMoney(monthlyRows.reduce((a, b) => a + b.usdTotal, 0)),
    monthlyRows.reduce((a, b) => a + b.anotherCount, 0),
    fmtMoney(monthlyRows.reduce((a, b) => a + b.anotherTotal, 0)),
  ]);
  monTotRow.height = 24;
  monTotRow.eachCell({ includeEmpty: true }, (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: AMBER_DARK } };
    cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  });

  sheet.addRow([]);

  // ---- STUDENT DETAILS section ----
  addMergedRow("STUDENT DETAILS", GREEN_DARK, 26, 13);

  const detHdrLabels = [
    "#", "National ID", "Full Name", "Phone", "Category",
    "Currency", "Invoice Date", "Invoice User", "Invoice Amount",
    "Another Invoice Date", "Another Invoice User", "Another Amount (EGP)",
  ];
  const detHdr = sheet.addRow(detHdrLabels);
  detHdr.height = 26;
  detHdr.eachCell((cell) => styleHeader(cell, GREEN_DARK));

  rows.forEach((r, idx) => {
    const invoiceInRange = isInRange(r.invoice_date);
    const anotherInRange = isInRange(r.another_invoice_date);
    const currency = getCurrency(r.category);
    const amount = invoiceInRange ? getInvoiceAmount(r) : 0;
    const anotherAmt = anotherInRange ? (Number(r.another_total_main) || 0) : null;
    const row = sheet.addRow([
      idx + 1,
      r.national_id,
      r.full_name,
      r.phone || "",
      r.category || "",
      currency,
      invoiceInRange ? fmtDate(r.invoice_date) : "",
      invoiceInRange ? (r.invoice_user || "") : "",
      invoiceInRange ? fmtMoney(amount) : "",
      anotherInRange ? fmtDate(r.another_invoice_date) : "",
      anotherInRange ? (r.another_invoice_user || "") : "",
      anotherInRange ? fmtMoney(anotherAmt) : "",
    ]);
    row.height = 20;
    const bg = idx % 2 === 0 ? EVEN_ROW : "FFFFFFFF";
    row.eachCell({ includeEmpty: true }, (cell) => styleData(cell, bg));
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `All_Invoices_Report_${dateFrom}_to_${dateTo}.xlsx`);
}

// ================================================================
// Shipping Report — students whose invoice shipping amount is not 0,
// filtered by Invoice Date. One sheet: summary by category + details.
// ================================================================
export async function excelShippingReport(dateFrom, dateTo) {
  const res = await exportShippingReport(dateFrom, dateTo);
  if (!res || res.status !== 200) {
    alert("Failed to fetch Shipping Report.");
    return;
  }
  const rows = res.data?.data || [];

  // Summary per category: how many students and total shipping
  const summaryMap = {};
  for (const r of rows) {
    const cat = r.category || "unknown";
    if (!summaryMap[cat]) summaryMap[cat] = { category: cat, count: 0, total: 0 };
    summaryMap[cat].count += 1;
    summaryMap[cat].total += Number(r.shipping) || 0;
  }
  const summaryRows = Object.values(summaryMap).sort((a, b) =>
    a.category.localeCompare(b.category)
  );

  const DARK_BLUE  = "FF1F4E79";
  const MID_BLUE   = "FF2E75B6";
  const LIGHT_BLUE = "FFD6E4F0";
  const EVEN_ROW   = "FFF2F7FB";
  const GREEN_DARK = "FF1D6A38";

  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString("en-GB");
  };
  const fmtMoney = (n) =>
    (n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "AATC System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Shipping Report");
  const COL_WIDTHS = [5, 18, 30, 18, 16, 16, 20, 16];
  COL_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });
  const NUM_COLS = COL_WIDTHS.length;

  const styleHeader = (cell, argb) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, size: 12, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleData = (cell, bg) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
    cell.font = { size: 11, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const addMergedRow = (text, argb, height = 24, fontSize = 13) => {
    const row = sheet.addRow([text]);
    row.height = height;
    sheet.mergeCells(row.number, 1, row.number, NUM_COLS);
    const cell = row.getCell(1);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, size: fontSize, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
  };

  // Title
  addMergedRow("Shipping Report", DARK_BLUE, 36, 18);
  addMergedRow(`Invoice Date Range:   ${dateFrom}  →  ${dateTo}`, LIGHT_BLUE, 22, 11);
  sheet.getRow(sheet.rowCount).getCell(1).font = {
    italic: true, size: 11, name: "Calibri", color: { argb: DARK_BLUE },
  };
  sheet.addRow([]);

  // ---- SUMMARY section ----
  addMergedRow("SUMMARY BY CATEGORY", MID_BLUE, 26, 13);
  const sumHdr = sheet.addRow(["Category", "Student Count", "Shipping Total"]);
  sumHdr.height = 26;
  sumHdr.eachCell((cell) => styleHeader(cell, MID_BLUE));
  summaryRows.forEach((sr, idx) => {
    const bg = idx % 2 === 0 ? EVEN_ROW : "FFFFFFFF";
    const r = sheet.addRow([sr.category, sr.count, fmtMoney(sr.total)]);
    r.height = 20;
    r.eachCell({ includeEmpty: true }, (cell) => styleData(cell, bg));
  });
  const sumTotRow = sheet.addRow([
    "TOTAL",
    summaryRows.reduce((a, b) => a + b.count, 0),
    fmtMoney(summaryRows.reduce((a, b) => a + b.total, 0)),
  ]);
  sumTotRow.height = 24;
  sumTotRow.eachCell({ includeEmpty: true }, (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: DARK_BLUE } };
    cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  });

  sheet.addRow([]);

  // ---- STUDENT DETAILS section ----
  addMergedRow("STUDENT DETAILS", GREEN_DARK, 26, 13);
  const detHdr = sheet.addRow([
    "#", "National ID", "Full Name", "Phone", "Category",
    "Invoice Date", "Invoice User", "Shipping Amount",
  ]);
  detHdr.height = 26;
  detHdr.eachCell((cell) => styleHeader(cell, GREEN_DARK));

  rows.forEach((r, idx) => {
    const row = sheet.addRow([
      idx + 1,
      r.national_id,
      r.full_name,
      r.phone || "",
      r.category || "",
      fmtDate(r.invoice_date),
      r.invoice_user || "",
      fmtMoney(Number(r.shipping) || 0),
    ]);
    row.height = 20;
    const bg = idx % 2 === 0 ? EVEN_ROW : "FFFFFFFF";
    row.eachCell({ includeEmpty: true }, (cell) => styleData(cell, bg));
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Shipping_Report_${dateFrom}_to_${dateTo}.xlsx`);
}


// ================================================================
// MOHE Statement Report — students who paid a MOHE Statement, filtered
// by MOHE payment date. One sheet: summary, then the payments.
// ================================================================
export async function excelMoheStatementReport(dateFrom, dateTo) {
  const res = await exportMoheStatementReport(dateFrom, dateTo);
  if (!res || res.status !== 200) {
    alert(res?.data?.ERROR || "Failed to fetch MOHE Statement Report.");
    return;
  }
  const rows = res.data?.data || [];

  const SOURCE_LABELS = { invoice: "Invoice", another_invoice: "Another Invoice" };
  const DARK_BLUE  = "FF1F4E79";
  const MID_BLUE   = "FF2E75B6";
  const LIGHT_BLUE = "FFD6E4F0";
  const EVEN_ROW   = "FFF2F7FB";
  const PURPLE     = "FF5B2C83";

  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(String(d).slice(0, 10));
    return isNaN(dt) ? d : dt.toLocaleDateString("en-GB");
  };
  // "2026-10-07 16:40" -> "07/10/2026 16:40"
  const fmtDateTime = (d) => {
    if (!d) return "";
    const [date, time] = String(d).split(" ");
    return `${fmtDate(date)}${time ? ` ${time}` : ""}`;
  };
  const fmtMoney = (n) =>
    (Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // Totals per currency (every MOHE Statement is EGP today).
  const totals = {};
  for (const r of rows) {
    const cur = r.currency || "EGP";
    totals[cur] = (totals[cur] || 0) + (Number(r.amount) || 0);
  }
  const studentCount = new Set(rows.map((r) => r.national_id)).size;
  // A refund (negative amount) takes its statements back off the count.
  const statementCount = rows.reduce(
    (a, r) => a + (Number(r.amount) < 0 ? -1 : 1) * (Number(r.quantity) || 0),
    0
  );

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "AATC System";
  workbook.created = new Date();
  const sheet = workbook.addWorksheet("MOHE Statement Report");
  const COL_WIDTHS = [5, 18, 30, 16, 18, 20, 16, 12, 16, 10];
  COL_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });
  const NUM_COLS = COL_WIDTHS.length;

  const border = {
    top: { style: "thin" }, left: { style: "thin" },
    bottom: { style: "thin" }, right: { style: "thin" },
  };
  const styleHeader = (cell, argb) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, size: 12, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = border;
  };
  const styleData = (cell, bg) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
    cell.font = { size: 11, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = border;
  };
  const addMergedRow = (text, argb, height = 24, fontSize = 13) => {
    const row = sheet.addRow([text]);
    row.height = height;
    sheet.mergeCells(row.number, 1, row.number, NUM_COLS);
    const cell = row.getCell(1);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, size: fontSize, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
  };

  // Title
  addMergedRow("MOHE Statement Report", DARK_BLUE, 36, 18);
  addMergedRow(`MOHE Payment Date Range:   ${dateFrom}  →  ${dateTo}`, LIGHT_BLUE, 22, 11);
  sheet.getRow(sheet.rowCount).getCell(1).font = {
    italic: true, size: 11, name: "Calibri", color: { argb: DARK_BLUE },
  };
  sheet.addRow([]);

  // ---- SUMMARY ----
  addMergedRow("SUMMARY", MID_BLUE, 26, 13);
  const sumHdr = sheet.addRow(["Students", "Payments", "Statements", "Amount Paid"]);
  sumHdr.height = 26;
  sumHdr.eachCell((cell) => styleHeader(cell, MID_BLUE));
  const amountText = Object.keys(totals).length
    ? Object.entries(totals).map(([cur, sum]) => `${fmtMoney(sum)} ${cur}`).join("  +  ")
    : `${fmtMoney(0)} EGP`;
  const sumRow = sheet.addRow([studentCount, rows.length, statementCount, amountText]);
  sumRow.height = 22;
  sumRow.eachCell({ includeEmpty: true }, (cell) => styleData(cell, EVEN_ROW));
  sheet.addRow([]);

  // ---- PAYMENTS ----
  addMergedRow("STUDENTS WHO PAID", PURPLE, 26, 13);
  const detHdr = sheet.addRow([
    "#", "National ID", "Full Name", "Phone Number", "Authentication Date (Invoice Date)",
    "MOHE Statement Payment Date", "Invoice", "No. of Statements", "Amount Paid", "Currency",
  ]);
  detHdr.height = 34;
  detHdr.eachCell((cell) => styleHeader(cell, PURPLE));

  if (!rows.length) {
    addMergedRow("No MOHE Statement payments in this date range.", "FF9CA3AF", 22, 11);
  }
  rows.forEach((r, idx) => {
    const row = sheet.addRow([
      idx + 1,
      r.national_id,
      r.full_name || "",
      r.phone || "",
      fmtDate(r.invoice_date),
      fmtDateTime(r.payment_date),
      SOURCE_LABELS[r.source] || r.source || "",
      Number(r.quantity) || 0,
      fmtMoney(r.amount),
      r.currency || "EGP",
    ]);
    row.height = 20;
    const bg = idx % 2 === 0 ? EVEN_ROW : "FFFFFFFF";
    row.eachCell({ includeEmpty: true }, (cell) => styleData(cell, bg));
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `MOHE_Statement_Report_${dateFrom}_to_${dateTo}.xlsx`);
}


// ================================================================
// Rush Students Report — students flagged Rush on either invoice,
// filtered by Authentication Date and optionally by delivery status
// ("all" / "delivered" / "not_delivered"). One sheet: summary by delivery
// status, category and state, then the student details.
// ================================================================
const RUSH_DELIVERY_LABELS = {
  all: "All",
  delivered: "Delivered",
  not_delivered: "Not Delivered",
};

export async function excelRushReport(dateFrom, dateTo, deliveryStatus = "all") {
  const res = await exportRushReport(dateFrom, dateTo);
  if (!res || res.status !== 200) {
    alert("Failed to fetch Rush Students Report.");
    return;
  }
  const allRows = res.data?.data || [];

  const STATE_LABELS = {
    auditing_new:       "Auditing New",
    request_edit:       "Request Edit",
    invoice:            "Invoice",
    invoice_wait:       "Invoice Wait",
    another_invoice:    "Another Invoice",
    score_validation:   "Score Validation",
    score_request:      "Score Request",
    score_pending:      "Score Pending",
    print:              "Print",
    print_validation:   "Print Validation",
    moe_validation:     "MOE Validation",
    moe:                "MOE",
    moe_pending:        "MOE Pending",
    moe_hold:           "MOE Hold",
    aatc_review:        "AATC Review",
    deliver:            "Deliver",
    mohe_validation:    "MOHE Validation",
    mohe:               "MOHE",
    done:               "Done",
  };
  const stateLabel = (s) => STATE_LABELS[s] || s || "";

  // Same rules as the Rush Students page: delivered once the state is
  // MOHE Validation / MOHE / Done; Days Since Authentication counts to today
  // for students not yet delivered; Delivered After counts to the MOHE date.
  const DELIVERED_STATES = ["mohe_validation", "mohe", "done"];
  const isDelivered = (state) => DELIVERED_STATES.includes(state);
  const toUtcDay = (v) => {
    const d = new Date(`${String(v).slice(0, 10)}T00:00:00Z`);
    return isNaN(d) ? null : d;
  };
  const daysBetween = (fromStr, toStr) => {
    if (!fromStr) return null;
    const start = toUtcDay(fromStr);
    if (!start) return null;
    let end;
    if (toStr) {
      end = toUtcDay(toStr);
      if (!end) return null;
    } else {
      const today = new Date();
      end = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
    }
    return Math.max(0, Math.round((end - start) / 86400000));
  };
  const formatDays = (n) => (n === null || n === undefined ? "—" : `${n} day${n === 1 ? "" : "s"}`);

  const rows = allRows.filter((r) =>
    deliveryStatus === "delivered"
      ? isDelivered(r.state)
      : deliveryStatus === "not_delivered"
        ? !isDelivered(r.state)
        : true
  );
  const deliveredCount = rows.filter((r) => isDelivered(r.state)).length;
  const deliveryRows = [
    { label: "Delivered", count: deliveredCount },
    { label: "Not Delivered", count: rows.length - deliveredCount },
  ].filter((e) => e.count > 0);

  // Counts per category and per state, for the summary blocks.
  const countBy = (key, label) => {
    const map = {};
    for (const r of rows) {
      const k = r[key] || "unknown";
      map[k] = (map[k] || 0) + 1;
    }
    return Object.entries(map)
      .map(([value, count]) => ({ label: label ? label(value) : value, count }))
      .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label));
  };
  const categoryRows = countBy("category");
  const stateRows = countBy("state", stateLabel);

  const DARK_BLUE  = "FF1F4E79";
  const MID_BLUE   = "FF2E75B6";
  const LIGHT_BLUE = "FFD6E4F0";
  const EVEN_ROW   = "FFF2F7FB";
  const GREEN_DARK = "FF1D6A38";
  // The same yellow the rush rows use on screen.
  const RUSH_AMBER = "FFFFEB9C";
  const RUSH_TEXT  = "FF7A5D00";

  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString("en-GB");
  };

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "AATC System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Rush Students");
  // Hidden for now; set to true to add the Actual Authentication Time column.
  const SHOW_ACTUAL_AUTH_TIME = false;
  const COL_WIDTHS = [5, 20, 30, 18, 20, 20, 18, 22, 18, 16, ...(SHOW_ACTUAL_AUTH_TIME ? [20] : [])];
  COL_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });
  const NUM_COLS = COL_WIDTHS.length;

  const styleHeader = (cell, argb) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, size: 12, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleData = (cell, bg) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
    cell.font = { size: 11, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const addMergedRow = (text, argb, height = 24, fontSize = 13, color = "FFFFFFFF") => {
    const row = sheet.addRow([text]);
    row.height = height;
    sheet.mergeCells(row.number, 1, row.number, NUM_COLS);
    const cell = row.getCell(1);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, size: fontSize, name: "Calibri", color: { argb: color } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
  };
  const addSummaryBlock = (title, entries, firstHeader) => {
    addMergedRow(title, MID_BLUE, 26, 13);
    const hdr = sheet.addRow([firstHeader, "Student Count"]);
    hdr.height = 26;
    hdr.eachCell((cell) => styleHeader(cell, MID_BLUE));
    entries.forEach((e, idx) => {
      const bg = idx % 2 === 0 ? EVEN_ROW : "FFFFFFFF";
      const r = sheet.addRow([e.label, e.count]);
      r.height = 20;
      r.eachCell({ includeEmpty: true }, (cell) => styleData(cell, bg));
    });
    const tot = sheet.addRow(["TOTAL", entries.reduce((a, b) => a + b.count, 0)]);
    tot.height = 24;
    tot.eachCell({ includeEmpty: true }, (cell) => {
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: DARK_BLUE } };
      cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      cell.border = {
        top: { style: "medium" }, left: { style: "thin" },
        bottom: { style: "medium" }, right: { style: "thin" },
      };
    });
    sheet.addRow([]);
  };

  // Title
  addMergedRow("Rush Students Report", DARK_BLUE, 36, 18);
  addMergedRow(`Authentication Date Range:   ${dateFrom}  to  ${dateTo}`, LIGHT_BLUE, 22, 11, DARK_BLUE);
  addMergedRow(
    `Delivery Status:   ${RUSH_DELIVERY_LABELS[deliveryStatus] || "All"}`,
    LIGHT_BLUE, 22, 11, DARK_BLUE
  );
  addMergedRow(`Total Rush Students: ${rows.length}`, RUSH_AMBER, 24, 13, RUSH_TEXT);
  sheet.addRow([]);

  addSummaryBlock("SUMMARY BY DELIVERY STATUS", deliveryRows, "Delivery Status");
  addSummaryBlock("SUMMARY BY CATEGORY", categoryRows, "Category");
  addSummaryBlock("SUMMARY BY STATE", stateRows, "State");

  // ---- STUDENT DETAILS section ----
  addMergedRow("STUDENT DETAILS", GREEN_DARK, 26, 13);
  const detHdr = sheet.addRow([
    "#", "National ID", "Full Name", "Phone",
    "Authentication Date", "State", "Category",
    "Days Since Authentication", "Delivered After", "Status",
    ...(SHOW_ACTUAL_AUTH_TIME ? ["Actual Authentication Time (Days)"] : []),
  ]);
  detHdr.height = 26;
  detHdr.eachCell((cell) => styleHeader(cell, GREEN_DARK));

  rows.forEach((r, idx) => {
    const delivered = isDelivered(r.state);
    const row = sheet.addRow([
      idx + 1,
      r.national_id,
      r.full_name,
      r.phone || "",
      fmtDate(r.authentication_date),
      stateLabel(r.state),
      r.category || "",
      delivered ? "—" : formatDays(daysBetween(r.authentication_date, null)),
      delivered ? formatDays(daysBetween(r.authentication_date, r.mohe_date)) : "—",
      delivered ? "Delivered" : "Not Delivered",
      ...(SHOW_ACTUAL_AUTH_TIME ? [r.actual_auth_days ?? ""] : []),
    ]);
    row.height = 20;
    const bg = idx % 2 === 0 ? EVEN_ROW : "FFFFFFFF";
    row.eachCell({ includeEmpty: true }, (cell) => styleData(cell, bg));
    // Status badge colours, matching the page (green / amber).
    const status = row.getCell(10);
    status.fill = {
      type: "pattern", pattern: "solid",
      fgColor: { argb: delivered ? "FFC6EFCE" : RUSH_AMBER },
    };
    status.font = {
      bold: true, size: 11, name: "Calibri",
      color: { argb: delivered ? "FF006100" : RUSH_TEXT },
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const statusSuffix = deliveryStatus === "all" ? "" : `_${RUSH_DELIVERY_LABELS[deliveryStatus].replace(" ", "_")}`;
  saveAs(blob, `Rush_Students_Report_${dateFrom}_to_${dateTo}${statusSuffix}.xlsx`);
}

// ================================================================
// Certificate Receivers Report — students transferred to MOHE Validation
// (the certificate receiving date) within the selected range, with the
// receiver's name and phone captured at transfer time.
// ================================================================
export async function excelCertificateReceiversReport(dateFrom, dateTo) {
  const res = await exportCertificateReceiversReport(dateFrom, dateTo);
  if (!res || res.status !== 200) {
    alert("Failed to fetch Certificate Receivers Report.");
    return;
  }
  const rows = res.data?.data || [];

  const DARK_BLUE  = "FF1F4E79";
  const LIGHT_BLUE = "FFD6E4F0";
  const EVEN_ROW   = "FFF2F7FB";
  const GREEN_DARK = "FF1D6A38";

  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString("en-GB");
  };

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "AATC System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Certificate Receivers");
  const COL_WIDTHS = [5, 20, 32, 20, 30, 22, 18, 18];
  COL_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });
  const NUM_COLS = COL_WIDTHS.length;

  const border = {
    top: { style: "thin" }, left: { style: "thin" },
    bottom: { style: "thin" }, right: { style: "thin" },
  };
  const addMergedRow = (text, argb, height = 24, fontSize = 13, color = "FFFFFFFF") => {
    const row = sheet.addRow([text]);
    row.height = height;
    sheet.mergeCells(row.number, 1, row.number, NUM_COLS);
    const cell = row.getCell(1);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, size: fontSize, name: "Calibri", color: { argb: color } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
  };

  addMergedRow("Certificate Receivers Report", DARK_BLUE, 36, 18);
  addMergedRow(`Receiving Date Range:   ${dateFrom}  to  ${dateTo}`, LIGHT_BLUE, 22, 11, DARK_BLUE);
  addMergedRow(`Total Students: ${rows.length}`, LIGHT_BLUE, 24, 13, DARK_BLUE);
  sheet.addRow([]);

  const hdr = sheet.addRow([
    "#", "National ID", "Student Name", "Authentication Date",
    "Receiver Name", "Receiver National ID", "Receiver Phone", "Receiving Date",
  ]);
  hdr.height = 26;
  hdr.eachCell((cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: GREEN_DARK } };
    cell.font = { bold: true, size: 12, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = border;
  });

  rows.forEach((r, idx) => {
    const row = sheet.addRow([
      idx + 1,
      r.national_id,
      r.full_name,
      fmtDate(r.authentication_date),
      r.receiver_name || "",
      r.receiver_national_id || "",
      r.receiver_phone || "",
      fmtDate(r.receiving_date),
    ]);
    row.height = 20;
    const bg = idx % 2 === 0 ? EVEN_ROW : "FFFFFFFF";
    row.eachCell({ includeEmpty: true }, (cell) => {
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
      cell.font = { size: 11, name: "Calibri" };
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      cell.border = border;
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Certificate_Receivers_Report_${dateFrom}_to_${dateTo}.xlsx`);
}

// ================================================================
// MOHE Report — students in MOHE / MOHE Validation / Done state whose
// Invoice Date is within the selected range (students whose invoice date is
// NOT in range are excluded by the server). Another Invoice Date is shown only
// when it also falls within the range. Students Count is shown at the top.
// ================================================================
export async function excelMoheReport(dateFrom, dateTo) {
  const res = await exportMoheReport(dateFrom, dateTo);
  if (!res || res.status !== 200) {
    alert("Failed to fetch MOHE Report.");
    return;
  }
  const rows = res.data?.data || [];

  const isInRange = (d) => !!d && d >= dateFrom && d <= dateTo;

  const STATE_LABELS = {
    auditing_new:       "Auditing New",
    request_edit:       "Request Edit",
    invoice:            "Invoice",
    invoice_wait:       "Invoice Wait",
    another_invoice:    "Another Invoice",
    score_validation:   "Score Validation",
    score_request:      "Score Request",
    score_pending:      "Score Pending",
    print:              "Print",
    print_validation:   "Print Validation",
    moe_validation:     "MOE Validation",
    moe:                "MOE",
    moe_pending:        "MOE Pending",
    aatc_review:        "AATC Review",
    deliver:            "Deliver",
    mohe_validation:    "MOHE Validation",
    mohe:               "MOHE",
    done:               "Done",
  };
  const stateLabel = (s) => STATE_LABELS[s] || s || "";

  // Stage summary — count per state
  const stageMap = {};
  for (const r of rows) {
    const key = r.state || "unknown";
    stageMap[key] = (stageMap[key] || 0) + 1;
  }
  const stageRows = Object.entries(stageMap)
    .map(([state, count]) => ({ state, label: stateLabel(state), count }))
    .sort((a, b) => b.count - a.count);

  const DARK_BLUE  = "FF1F4E79";
  const MID_BLUE   = "FF2E75B6";
  const LIGHT_BLUE = "FFD6E4F0";
  const EVEN_ROW   = "FFF2F7FB";
  const GREEN_DARK = "FF1D6A38";
  const AMBER_MID  = "FFB45309";
  const AMBER_ROW  = "FFFEF3C7";

  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString("en-GB");
  };

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "AATC System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("MOHE Report");
  const COL_WIDTHS = [5, 30, 20, 18, 16, 20, 18, 20];
  COL_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });
  const NUM_COLS = COL_WIDTHS.length;

  const styleHeader = (cell, argb) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, size: 12, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleData = (cell, bg) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
    cell.font = { size: 11, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const addMergedRow = (text, argb, height = 24, fontSize = 13) => {
    const row = sheet.addRow([text]);
    row.height = height;
    sheet.mergeCells(row.number, 1, row.number, NUM_COLS);
    const cell = row.getCell(1);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, size: fontSize, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
  };

  // Title
  addMergedRow("MOHE Report", DARK_BLUE, 36, 18);
  addMergedRow(`Invoice Date Range:   ${dateFrom}  →  ${dateTo}`, LIGHT_BLUE, 22, 11);
  sheet.getRow(sheet.rowCount).getCell(1).font = {
    italic: true, size: 11, name: "Calibri", color: { argb: DARK_BLUE },
  };
  addMergedRow(`Students Count:   ${rows.length}`, MID_BLUE, 26, 14);
  sheet.addRow([]);

  const styleTotalRow = (row, argb) => {
    row.height = 24;
    row.eachCell({ includeEmpty: true }, (cell) => {
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
      cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = {
        top: { style: "medium" }, left: { style: "thin" },
        bottom: { style: "medium" }, right: { style: "thin" },
      };
    });
  };

  const MOHE_STATES = new Set(["mohe", "mohe_validation", "done"]);

  // ---- TABLE 1: ALL STAGES (excluding MOHE / MOHE Validation / Done) ----
  addMergedRow("SUMMARY BY STAGE — ALL", AMBER_MID, 26, 13);
  const allHdr = sheet.addRow(["Stage", "Student Count"]);
  allHdr.height = 26;
  allHdr.eachCell((cell) => styleHeader(cell, AMBER_MID));

  const nonMoheStageRows = stageRows.filter((sr) => !MOHE_STATES.has(sr.state));
  const nonMoheTotal = nonMoheStageRows.reduce((a, b) => a + b.count, 0);

  nonMoheStageRows.forEach((sr, idx) => {
    const bg = idx % 2 === 0 ? AMBER_ROW : "FFFFFFFF";
    const r = sheet.addRow([sr.label, sr.count]);
    r.height = 20;
    r.eachCell({ includeEmpty: true }, (cell) => styleData(cell, bg));
  });

  styleTotalRow(sheet.addRow(["TOTAL", nonMoheTotal]), DARK_BLUE);
  sheet.addRow([]);

  // ---- TABLE 2: MOHE / MOHE VALIDATION / DONE ----
  const moheStageRows = stageRows.filter((sr) => MOHE_STATES.has(sr.state));
  const moheTotal = moheStageRows.reduce((a, b) => a + b.count, 0);

  addMergedRow("SUMMARY BY STAGE — MOHE / MOHE VALIDATION / DONE", MID_BLUE, 26, 13);
  const moheHdr = sheet.addRow(["Stage", "Student Count"]);
  moheHdr.height = 26;
  moheHdr.eachCell((cell) => styleHeader(cell, MID_BLUE));

  moheStageRows.forEach((sr, idx) => {
    const bg = idx % 2 === 0 ? EVEN_ROW : "FFFFFFFF";
    const r = sheet.addRow([sr.label, sr.count]);
    r.height = 20;
    r.eachCell({ includeEmpty: true }, (cell) => styleData(cell, bg));
  });

  styleTotalRow(sheet.addRow(["TOTAL", moheTotal]), DARK_BLUE);
  sheet.addRow([]);

  // ---- STUDENT DETAILS section ----
  addMergedRow("STUDENT DETAILS", GREEN_DARK, 26, 13);
  const detHdr = sheet.addRow([
    "#", "Full Name", "National ID", "Phone", "Invoice Category", "State",
    "Invoice Date", "Another Invoice Date",
  ]);
  detHdr.height = 26;
  detHdr.eachCell((cell) => styleHeader(cell, GREEN_DARK));

  rows.forEach((r, idx) => {
    const invoiceInRange = isInRange(r.invoice_date);
    const anotherInRange = isInRange(r.another_invoice_date);
    const row = sheet.addRow([
      idx + 1,
      r.full_name,
      r.national_id,
      r.phone || "",
      r.category || "",
      stateLabel(r.state),
      invoiceInRange ? fmtDate(r.invoice_date) : "",
      anotherInRange ? fmtDate(r.another_invoice_date) : "",
    ]);
    row.height = 20;
    const bg = idx % 2 === 0 ? EVEN_ROW : "FFFFFFFF";
    row.eachCell({ includeEmpty: true }, (cell) => styleData(cell, bg));
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `MOHE_Report_${dateFrom}_to_${dateTo}.xlsx`);
}

// ================================================================
// Colleges Report  — filtered by Invoice Date (or Another Invoice Date)
//   Sheet 1 "Summary":   per-college student counts (a student is counted
//                        in every college they selected) + grade 11 / 12
//                        enrolment counts.
//   Sheet 2 "By College": student rows grouped by college name — a student
//                        who chose N colleges appears N times.
//   Sheet 3 "Grade 11":  students enrolled in grade 11.
//   Sheet 4 "Grade 12":  students enrolled in grade 12.
//   Columns: National ID, Full Name, Phone, Invoice Date, Another Invoice Date
// ================================================================
export async function excelCollegesReport(dateFrom, dateTo) {
  const res = await exportCollegesReport(dateFrom, dateTo);
  if (!res || res.status !== 200) {
    alert("Failed to fetch Colleges Report.");
    return;
  }
  const rows = res.data?.data || [];

  const isInRange = (d) => !!d && d >= dateFrom && d <= dateTo;
  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString("en-GB");
  };
  const normKey = (s) => (s || "").trim().replace(/\s+/g, " ").toLowerCase();
  const toTitle = (s) =>
    (s || "")
      .trim()
      .replace(/\s+/g, " ")
      .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());

  const getColleges = (r) =>
    [r.college1, r.college2, r.college3, r.college4, r.college5]
      .map((c) => (c || "").trim())
      .filter(Boolean);

  // ---- per-college aggregation (student counted in each college chosen) ----
  // Returns [{ label, students: [row, ...] }] sorted by count desc. A student
  // with N colleges appears in N groups. When includeUngrouped is set, rows
  // with no college fall into a trailing "(No College)" group instead of being
  // dropped.
  const buildCollegeGroups = (sourceRows, includeUngrouped = false) => {
    const map = new Map();
    const ungrouped = [];
    for (const r of sourceRows) {
      const cols = getColleges(r);
      if (cols.length === 0) {
        ungrouped.push(r);
        continue;
      }
      const seen = new Set(); // de-dupe a college repeated within the same student
      for (const c of cols) {
        const key = normKey(c);
        if (!key || seen.has(key)) continue;
        seen.add(key);
        if (!map.has(key)) map.set(key, { label: toTitle(c), students: [] });
        map.get(key).students.push(r);
      }
    }
    const groups = [...map.values()].sort(
      (a, b) => b.students.length - a.students.length || a.label.localeCompare(b.label)
    );
    if (includeUngrouped && ungrouped.length) {
      groups.push({ label: "(No College)", students: ungrouped });
    }
    return groups;
  };
  const collegeGroups = buildCollegeGroups(rows);

  // ---- grade enrolment ----
  const grade11 = rows.filter((r) => r.grade_status === "is enrolled in grade 11");
  const grade12 = rows.filter((r) => r.grade_status === "is enrolled in grade 12");

  // ---- palette ----
  const DARK = "FF1F4E79";
  const MID = "FF2E75B6";
  const LIGHT = "FFD6E4F0";
  const EVEN = "FFF2F7FB";
  const GREEN_DARK = "FF1D6A38";

  // ---- shared style helpers ----
  const styleHeader = (cell, argb) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, size: 12, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleData = (cell, bg) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
    cell.font = { size: 11, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin", color: { argb: "FFD0D7E5" } },
      left: { style: "thin", color: { argb: "FFD0D7E5" } },
      bottom: { style: "thin", color: { argb: "FFD0D7E5" } },
      right: { style: "thin", color: { argb: "FFD0D7E5" } },
    };
  };
  const addBanner = (sheet, text, numCols, argb, height, size, fontArgb = "FFFFFFFF", italic = false) => {
    const row = sheet.addRow([text]);
    row.height = height;
    sheet.mergeCells(row.number, 1, row.number, numCols);
    const cell = row.getCell(1);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: !italic, italic, size, name: "Calibri", color: { argb: fontArgb } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    return row;
  };

  // builds the 5 student-detail cells for a row
  const studentCells = (r) => [
    r.national_id,
    r.full_name,
    r.phone || "",
    isInRange(r.invoice_date) ? fmtDate(r.invoice_date) : "",
    isInRange(r.another_invoice_date) ? fmtDate(r.another_invoice_date) : "",
  ];
  const DETAIL_HEADERS = [
    "National ID", "Full Name", "Phone Number", "Invoice Date", "Another Invoice Date",
  ];
  const DETAIL_WIDTHS = [22, 34, 18, 16, 20];

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "AATC System";
  workbook.created = new Date();

  // ================================================================
  // SHEET 1 — Summary
  // ================================================================
  const sumSheet = workbook.addWorksheet("Summary");
  sumSheet.getColumn(1).width = 46;
  sumSheet.getColumn(2).width = 18;

  addBanner(sumSheet, "Colleges Report", 2, DARK, 34, 18);
  addBanner(sumSheet, `Invoice Date Range:   ${dateFrom}  →  ${dateTo}`, 2, LIGHT, 22, 11, DARK, true);
  addBanner(sumSheet, `Total Students: ${rows.length}`, 2, "FFEAF0FB", 22, 12, DARK);
  sumSheet.addRow([]);

  // Grade enrolment block
  addBanner(sumSheet, "ENROLMENT SUMMARY", 2, GREEN_DARK, 24, 13);
  const gHdr = sumSheet.addRow(["Grade", "Students"]);
  gHdr.height = 22;
  gHdr.eachCell((cell) => styleHeader(cell, GREEN_DARK));
  [
    ["Is enrolled in grade 11", grade11.length],
    ["Is enrolled in grade 12", grade12.length],
  ].forEach(([label, count], idx) => {
    const r = sumSheet.addRow([label, count]);
    r.height = 20;
    const bg = idx % 2 === 0 ? EVEN : "FFFFFFFF";
    r.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
    styleData(r.getCell(1), bg);
    r.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
    styleData(r.getCell(2), bg);
  });
  sumSheet.addRow([]);

  // Per-college counts block
  addBanner(sumSheet, "STUDENTS PER COLLEGE", 2, MID, 24, 13);
  const cHdr = sumSheet.addRow(["College Name", "Students Count"]);
  cHdr.height = 24;
  cHdr.eachCell((cell) => styleHeader(cell, MID));
  collegeGroups.forEach((g, idx) => {
    const r = sumSheet.addRow([g.label, g.students.length]);
    r.height = 20;
    const bg = idx % 2 === 0 ? EVEN : "FFFFFFFF";
    styleData(r.getCell(1), bg);
    r.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
    styleData(r.getCell(2), bg);
  });
  // total row (sum of per-college counts — students with multiple colleges count multiple times)
  const totRow = sumSheet.addRow([
    `TOTAL (${collegeGroups.length} colleges)`,
    collegeGroups.reduce((a, g) => a + g.students.length, 0),
  ]);
  totRow.height = 24;
  totRow.eachCell({ includeEmpty: true }, (cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: DARK } };
    cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  });
  sumSheet.getRow(totRow.number).getCell(1).alignment = { vertical: "middle", horizontal: "left" };
  sumSheet.views = [];

  // ================================================================
  // SHEET 2 — By College  (student appears once per college chosen)
  // ================================================================
  const byCollegeSheet = workbook.addWorksheet("By College");
  DETAIL_WIDTHS.forEach((w, i) => { byCollegeSheet.getColumn(i + 1).width = w; });

  const bcHdr = byCollegeSheet.addRow(DETAIL_HEADERS);
  bcHdr.height = 26;
  bcHdr.eachCell((cell) => styleHeader(cell, DARK));

  collegeGroups.forEach((g) => {
    // college group banner spanning all detail columns
    const gr = byCollegeSheet.addRow([`${g.label}  —  ${g.students.length} student(s)`]);
    gr.height = 22;
    byCollegeSheet.mergeCells(gr.number, 1, gr.number, DETAIL_HEADERS.length);
    const gc = gr.getCell(1);
    gc.fill = { type: "pattern", pattern: "solid", fgColor: { argb: MID } };
    gc.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    gc.alignment = { vertical: "middle", horizontal: "left", indent: 1 };

    g.students.forEach((r, idx) => {
      const dr = byCollegeSheet.addRow(studentCells(r));
      dr.height = 20;
      const bg = idx % 2 === 0 ? EVEN : "FFFFFFFF";
      dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
        styleData(cell, bg);
        if (colNum === 2) cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      });
    });
  });

  byCollegeSheet.views = [{ state: "frozen", ySplit: 1 }];

  // ================================================================
  // SHEETS 3 & 4 — Grade 11 / Grade 12  (grouped by college, one record
  // per chosen college, with the college name shown next to the student)
  // ================================================================
  const GRADE_HEADERS = [
    "National ID", "Full Name", "Phone Number", "College Name",
    "Invoice Date", "Another Invoice Date",
  ];
  const GRADE_WIDTHS = [22, 34, 18, 40, 16, 20];
  const gradeStudentCells = (r, collegeLabel) => [
    r.national_id,
    r.full_name,
    r.phone || "",
    collegeLabel,
    isInRange(r.invoice_date) ? fmtDate(r.invoice_date) : "",
    isInRange(r.another_invoice_date) ? fmtDate(r.another_invoice_date) : "",
  ];

  const addGradeSheet = (name, label, gradeRows, headerArgb, rowBg) => {
    const sheet = workbook.addWorksheet(name);
    GRADE_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });

    const groups = buildCollegeGroups(gradeRows, true);
    // total record count = students expanded per college
    const totalRecords = groups.reduce((a, g) => a + g.students.length, 0);

    addBanner(
      sheet,
      `${label} — ${gradeRows.length} student(s), ${totalRecords} record(s) across ${groups.length} college(s)`,
      GRADE_HEADERS.length, headerArgb, 26, 12
    );
    const hdr = sheet.addRow(GRADE_HEADERS);
    hdr.height = 26;
    hdr.eachCell((cell) => styleHeader(cell, headerArgb));

    groups.forEach((g) => {
      // college group banner spanning all columns
      const gr = sheet.addRow([`${g.label}  —  ${g.students.length} student(s)`]);
      gr.height = 22;
      sheet.mergeCells(gr.number, 1, gr.number, GRADE_HEADERS.length);
      const gc = gr.getCell(1);
      gc.fill = { type: "pattern", pattern: "solid", fgColor: { argb: MID } };
      gc.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
      gc.alignment = { vertical: "middle", horizontal: "left", indent: 1 };

      g.students.forEach((r, idx) => {
        const dr = sheet.addRow(gradeStudentCells(r, g.label));
        dr.height = 20;
        const bg = idx % 2 === 0 ? rowBg : "FFFFFFFF";
        dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
          styleData(cell, bg);
          if (colNum === 2 || colNum === 4)
            cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        });
      });
    });

    sheet.views = [{ state: "frozen", ySplit: 2 }];
  };

  addGradeSheet("Grade 11", "Is enrolled in grade 11", grade11, GREEN_DARK, "FFE8F5E9");
  addGradeSheet("Grade 12", "Is enrolled in grade 12", grade12, DARK, EVEN);

  // ---- save ----
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Colleges_Report_${dateFrom}_to_${dateTo}.xlsx`);
}

// ================================================================
// SCHOOLS REPORTS — client-side only (school rows passed directly)
//   Report 1: All Schools — restricted rows highlighted in red
//   Report 2: Restricted Schools only
// ================================================================

// Shared style helpers for the schools workbooks
const schStyleHeader = (cell, argb) => {
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
  cell.font = { bold: true, size: 12, name: "Calibri", color: { argb: "FFFFFFFF" } };
  cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
  cell.border = {
    top: { style: "thin" }, left: { style: "thin" },
    bottom: { style: "thin" }, right: { style: "thin" },
  };
};
const schStyleData = (cell, bg, fontArgb = "FF000000") => {
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
  cell.font = { size: 11, name: "Calibri", color: { argb: fontArgb } };
  cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
  cell.border = {
    top: { style: "thin", color: { argb: "FFD0D7E5" } },
    left: { style: "thin", color: { argb: "FFD0D7E5" } },
    bottom: { style: "thin", color: { argb: "FFD0D7E5" } },
    right: { style: "thin", color: { argb: "FFD0D7E5" } },
  };
};
const schAddBanner = (sheet, text, numCols, argb, height, size, fontArgb = "FFFFFFFF", italic = false) => {
  const row = sheet.addRow([text]);
  row.height = height;
  sheet.mergeCells(row.number, 1, row.number, numCols);
  const cell = row.getCell(1);
  cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
  cell.font = { bold: !italic, italic, size, name: "Calibri", color: { argb: fontArgb } };
  cell.alignment = { vertical: "middle", horizontal: "center" };
  return row;
};

const SCH_DARK       = "FF1F4E79"; // header / title navy
const SCH_MID        = "FF2E75B6"; // sub-banner blue
const SCH_EVEN       = "FFF2F7FB"; // zebra (light blue)
const SCH_RED_DARK   = "FF9C0006"; // restricted banner / text
const SCH_RED_FILL   = "FFFFC7CE"; // restricted row fill (Excel "bad" red)
const SCH_RED_ALT    = "FFFFD9DD"; // restricted row fill (alt zebra)

// ── Report 1: All Schools (restricted rows highlighted red) ──
export async function exportAllSchoolsExcel(schools) {
  const rows = Array.isArray(schools) ? schools : [];
  const restrictedCount = rows.filter((s) => s.restricted).length;

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("All Schools");
  const COL_WIDTHS = [8, 40, 24, 22, 16];
  COL_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });
  const NUM_COLS = COL_WIDTHS.length;

  // Banners
  schAddBanner(sheet, "Schools Report — All Schools", NUM_COLS, SCH_DARK, 34, 18);
  schAddBanner(sheet, `Generated: ${new Date().toLocaleString("en-GB")}`, NUM_COLS, "FFD6E4F0", 20, 11, SCH_DARK, true);
  schAddBanner(sheet, `Total Schools: ${rows.length}   |   Restricted: ${restrictedCount}`, NUM_COLS, "FFEAF0FB", 22, 12, SCH_DARK);
  sheet.addRow([]); // spacer

  // Column headers
  const hdr = sheet.addRow(["#", "School Name", "City", "Country", "Restricted"]);
  hdr.height = 26;
  hdr.eachCell((cell) => schStyleHeader(cell, SCH_DARK));

  rows.forEach((s, idx) => {
    const isRestricted = !!s.restricted;
    const dr = sheet.addRow([
      idx + 1,
      s.school_name || "",
      s.school_city || "",
      s.school_country || "",
      isRestricted ? "Restricted" : "No",
    ]);
    dr.height = 20;
    // Restricted rows use a red fill + dark-red bold text; others use zebra.
    const bg = isRestricted
      ? (idx % 2 === 0 ? SCH_RED_FILL : SCH_RED_ALT)
      : (idx % 2 === 0 ? SCH_EVEN : "FFFFFFFF");
    const fontArgb = isRestricted ? SCH_RED_DARK : "FF000000";
    dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
      schStyleData(cell, bg, fontArgb);
      if (colNum === 2) cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      if (isRestricted) cell.font = { size: 11, name: "Calibri", bold: true, color: { argb: SCH_RED_DARK } };
    });
  });

  sheet.views = [{ state: "frozen", ySplit: 4 }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `All_Schools_${new Date().toISOString().slice(0, 10)}.xlsx`);
}

// ── Report 2: Restricted Schools only ──
export async function exportRestrictedSchoolsExcel(schools) {
  const rows = (Array.isArray(schools) ? schools : []).filter((s) => s.restricted);

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Restricted Schools");
  const COL_WIDTHS = [8, 40, 24, 22];
  COL_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });
  const NUM_COLS = COL_WIDTHS.length;

  // Banners (red theme to signal restriction)
  schAddBanner(sheet, "Schools Report — Restricted Schools", NUM_COLS, SCH_RED_DARK, 34, 18);
  schAddBanner(sheet, `Generated: ${new Date().toLocaleString("en-GB")}`, NUM_COLS, "FFFFD9DD", 20, 11, SCH_RED_DARK, true);
  schAddBanner(sheet, `Total Restricted Schools: ${rows.length}`, NUM_COLS, "FFFFEBEE", 22, 12, SCH_RED_DARK);
  sheet.addRow([]); // spacer

  // Column headers
  const hdr = sheet.addRow(["#", "School Name", "City", "Country"]);
  hdr.height = 26;
  hdr.eachCell((cell) => schStyleHeader(cell, SCH_RED_DARK));

  rows.forEach((s, idx) => {
    const dr = sheet.addRow([
      idx + 1,
      s.school_name || "",
      s.school_city || "",
      s.school_country || "",
    ]);
    dr.height = 20;
    const bg = idx % 2 === 0 ? SCH_RED_FILL : SCH_RED_ALT;
    dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
      schStyleData(cell, bg, SCH_RED_DARK);
      cell.font = { size: 11, name: "Calibri", bold: true, color: { argb: SCH_RED_DARK } };
      if (colNum === 2) cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    });
  });

  if (rows.length === 0) {
    const emptyRow = sheet.addRow(["No restricted schools found."]);
    sheet.mergeCells(emptyRow.number, 1, emptyRow.number, NUM_COLS);
    emptyRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    emptyRow.getCell(1).font = { italic: true, size: 11, name: "Calibri", color: { argb: "FF888888" } };
  }

  sheet.views = [{ state: "frozen", ySplit: 4 }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Restricted_Schools_${new Date().toISOString().slice(0, 10)}.xlsx`);
}

// ================================================================
// Schools Report (MOE States) — students in the selected MOE states
// (any of MOE Hold, MOE Validation, Sending to MOE, MOE Pending) whose
// Invoice Date falls within [dateFrom, dateTo].
//   • `states` limits which MOE states are included (empty = all four).
//   • Top of sheet: count per selected state + students in restricted schools.
//   • Details: National ID, Full Name, Phone, State, Invoice Date,
//     School Name, School City, School Country.
//   • Students in restricted schools are highlighted in red.
// ================================================================
export async function excelSchoolsStateReport(dateFrom, dateTo, states) {
  const res = await exportSchoolsStateReport(dateFrom, dateTo, states);
  if (!res || res.status !== 200) {
    alert("Failed to fetch Schools Report. Please try again.");
    return;
  }
  const rows = res.data?.data || [];

  const fmtInputDate = (yyyymmdd) => {
    if (!yyyymmdd) return "";
    const [y, m, d] = yyyymmdd.split("-").map(Number);
    if (!y || !m || !d) return yyyymmdd;
    return new Date(y, m - 1, d).toLocaleDateString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
    });
  };

  const STATE_LABELS = {
    moe_hold:       "MOE Hold",
    moe_validation: "MOE Validation",
    moe:            "Sending to MOE",
    moe_pending:    "MOE Pending",
  };
  const STATE_ORDER = ["moe_hold", "moe_validation", "moe", "moe_pending"];
  const stateLabel = (s) => STATE_LABELS[s] || s || "";

  // Whitelist the requested states against the canonical order (keeping that
  // order); default to all four when none were selected.
  let selectedStates = Array.isArray(states)
    ? STATE_ORDER.filter((s) => states.includes(s))
    : [];
  if (selectedStates.length === 0) selectedStates = STATE_ORDER;

  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString("en-GB");
  };
  const isInRange = (d) => !!d && d >= dateFrom && d <= dateTo;
  const isRestricted = (r) => Number(r.restricted) === 1;

  // Per-state counts + restricted count (only the selected states are tallied)
  const stateCounts = {};
  selectedStates.forEach((s) => { stateCounts[s] = 0; });
  let restrictedStudents = 0;
  rows.forEach((r) => {
    if (stateCounts[r.state] === undefined) stateCounts[r.state] = 0;
    stateCounts[r.state] += 1;
    if (isRestricted(r)) restrictedStudents += 1;
  });

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Schools Report");
  const COL_WIDTHS = [22, 30, 18, 18, 16, 18, 34, 22, 20];
  COL_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });
  const NUM_COLS = COL_WIDTHS.length;

  // ── Title banners ──
  schAddBanner(sheet, "Schools Report — MOE States", NUM_COLS, SCH_DARK, 34, 18);
  schAddBanner(sheet, `Invoice Date Range:   ${fmtInputDate(dateFrom)}  →  ${fmtInputDate(dateTo)}`, NUM_COLS, "FFD6E4F0", 20, 11, SCH_DARK, true);
  schAddBanner(sheet, `States: ${selectedStates.map(stateLabel).join(", ")}`, NUM_COLS, "FFEAF0FB", 20, 11, SCH_DARK, true);
  schAddBanner(sheet, `Total Students: ${rows.length}`, NUM_COLS, "FFEAF0FB", 22, 12, SCH_DARK);
  sheet.addRow([]); // spacer

  // ── Summary block: count per state + restricted-school count ──
  schAddBanner(sheet, "SUMMARY", NUM_COLS, SCH_MID, 24, 13);
  const sumHdr = sheet.addRow(["State", "Student Count"]);
  sumHdr.height = 24;
  [1, 2].forEach((c) => schStyleHeader(sumHdr.getCell(c), SCH_MID));

  selectedStates.forEach((s, idx) => {
    const r = sheet.addRow([stateLabel(s), stateCounts[s] || 0]);
    r.height = 20;
    const bg = idx % 2 === 0 ? SCH_EVEN : "FFFFFFFF";
    [1, 2].forEach((c) => {
      schStyleData(r.getCell(c), bg);
      r.getCell(c).alignment = { vertical: "middle", horizontal: c === 1 ? "left" : "center" };
    });
  });

  // Total row for states
  const stateTotRow = sheet.addRow(["TOTAL", rows.length]);
  stateTotRow.height = 22;
  [1, 2].forEach((c) => {
    const cell = stateTotRow.getCell(c);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: SCH_DARK } };
    cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: c === 1 ? "left" : "center" };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  });

  // Restricted-schools count row (red highlight)
  const restrictedRow = sheet.addRow(["Students in Restricted Schools", restrictedStudents]);
  restrictedRow.height = 22;
  [1, 2].forEach((c) => {
    const cell = restrictedRow.getCell(c);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: SCH_RED_DARK } };
    cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: c === 1 ? "left" : "center" };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  });
  sheet.addRow([]); // spacer

  // ── Detail table ──
  schAddBanner(sheet, "STUDENT DETAILS", NUM_COLS, "FF1D6A38", 24, 13);
  const hdr = sheet.addRow([
    "National ID", "Full Name", "Phone Number", "State",
    "Invoice Date", "Another Invoice Date", "School Name", "School City", "School Country",
  ]);
  hdr.height = 26;
  hdr.eachCell((cell) => schStyleHeader(cell, "FF1D6A38"));

  rows.forEach((r, idx) => {
    const restricted = isRestricted(r);
    const invoiceInRange = isInRange(r.invoice_date);
    const anotherInRange = isInRange(r.another_invoice_date);
    const dr = sheet.addRow([
      r.national_id || "",
      r.full_name || "",
      r.phone || "",
      stateLabel(r.state),
      invoiceInRange ? fmtDate(r.invoice_date) : "",
      anotherInRange ? fmtDate(r.another_invoice_date) : "",
      r.school_name || "",
      r.school_city || "",
      r.school_country || "",
    ]);
    dr.height = 20;
    // Restricted-school students get the red fill + bold dark-red text.
    const bg = restricted
      ? (idx % 2 === 0 ? SCH_RED_FILL : SCH_RED_ALT)
      : (idx % 2 === 0 ? SCH_EVEN : "FFFFFFFF");
    const fontArgb = restricted ? SCH_RED_DARK : "FF000000";
    dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
      schStyleData(cell, bg, fontArgb);
      // Full Name (col 2) and School Name (col 7) left-aligned.
      if (colNum === 2 || colNum === 7) cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      if (restricted) cell.font = { size: 11, name: "Calibri", bold: true, color: { argb: SCH_RED_DARK } };
    });
  });

  if (rows.length === 0) {
    const emptyRow = sheet.addRow(["No students found in the MOE states."]);
    sheet.mergeCells(emptyRow.number, 1, emptyRow.number, NUM_COLS);
    emptyRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    emptyRow.getCell(1).font = { italic: true, size: 11, name: "Calibri", color: { argb: "FF888888" } };
  }

  // No frozen panes — the summary sits above the detail table, so freezing the
  // header would lock the whole summary block and make the sheet feel stuck.
  // Leave the sheet fully scrollable.
  sheet.views = [{ showGridLines: true }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Schools_Report_${dateFrom}_to_${dateTo}.xlsx`);
}

// ================================================================
// Enrollment Letters — Upload History report. Exports every student with
// an uploaded enrollment letter (optionally filtered by the same search
// term used on the History tab): who uploaded it, when, who it's assigned
// to, and their current workflow state.
// ================================================================
export async function excelEnrollmentLetterHistoryReport(search) {
  const res = await getEnrollmentLetterHistoryExport(search);
  if (!res || res.status !== 200) {
    alert("Failed to fetch Enrollment Letters history. Please try again.");
    return;
  }
  const rows = res.data?.data || [];

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Enrollment Letters History");
  const COL_WIDTHS = [22, 30, 18, 18, 18, 18, 20, 14, 18];
  COL_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });
  const NUM_COLS = COL_WIDTHS.length;

  schAddBanner(sheet, "Enrollment Letters — Upload History", NUM_COLS, SCH_DARK, 34, 18);
  schAddBanner(sheet, `Total Uploaded: ${rows.length}`, NUM_COLS, SCH_MID, 24, 13);
  sheet.addRow([]); // spacer

  const hdr = sheet.addRow([
    "National ID", "Full Name", "Passport Number", "State",
    "Assigned To", "Uploaded By", "Uploaded At", "Confirmed", "Confirmed By",
  ]);
  hdr.height = 26;
  hdr.eachCell((cell) => schStyleHeader(cell, "FF1D6A38"));

  rows.forEach((r, idx) => {
    const confirmed = Number(r.enrollment_letter_confirmed) === 1;
    const dr = sheet.addRow([
      r.national_id || "",
      r.full_name || "",
      r.passport_number || "",
      r.state || "",
      r.enrollment_letter_assigned_user || "",
      r.enrollment_letter_uploaded_by || "",
      r.enrollment_letter_date || "",
      confirmed ? "Yes" : "No",
      confirmed ? (r.enrollment_letter_confirmed_by || "") : "",
    ]);
    dr.height = 20;
    const bg = idx % 2 === 0 ? SCH_EVEN : "FFFFFFFF";
    dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
      schStyleData(cell, bg);
      if (colNum === 2) cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    });
  });

  if (rows.length === 0) {
    const emptyRow = sheet.addRow(["No enrollment letters have been uploaded yet."]);
    sheet.mergeCells(emptyRow.number, 1, emptyRow.number, NUM_COLS);
    emptyRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    emptyRow.getCell(1).font = { italic: true, size: 11, name: "Calibri", color: { argb: "FF888888" } };
  }

  sheet.views = [{ state: "frozen", ySplit: 4 }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Enrollment_Letters_History_${new Date().toISOString().slice(0, 10)}.xlsx`);
}

// ================================================================
// Missing Enrollment Letters Report — same column layout as the Schools
// Report, but scoped to students in ANY workflow state whose enrollment
// letter is explicitly "No" (not restricted to MOE states, no restricted-
// school highlighting). Filtered by Invoice Date OR Another Invoice Date
// falling within [dateFrom, dateTo]. Summary is a per-state breakdown
// (like the MOHE Report) instead of a restricted-schools count.
// ================================================================
export async function excelMissingEnrollmentLettersReport(dateFrom, dateTo) {
  const res = await exportMissingEnrollmentLettersReport(dateFrom, dateTo);
  if (!res || res.status !== 200) {
    alert("Failed to fetch Missing Enrollment Letters Report. Please try again.");
    return;
  }
  const rows = res.data?.data || [];

  const fmtInputDate = (yyyymmdd) => {
    if (!yyyymmdd) return "";
    const [y, m, d] = yyyymmdd.split("-").map(Number);
    if (!y || !m || !d) return yyyymmdd;
    return new Date(y, m - 1, d).toLocaleDateString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
    });
  };

  const STATE_LABELS = {
    auditing_new:       "Auditing New",
    auditing_pending:   "Auditing Pending",
    request_edit:       "Request Edit",
    invoice:            "Invoice",
    invoice_wait:       "Invoice Wait",
    another_invoice:    "Another Invoice",
    score_validation:   "Score Validation",
    score_request:      "Score Request",
    score_pending:      "Score Pending",
    print:              "Print",
    print_validation:   "Print Validation",
    moe_hold:           "MOE Hold",
    moe_validation:     "MOE Validation",
    moe:                "Sending to MOE",
    moe_pending:        "MOE Pending",
    aatc_review:        "AATC Review",
    deliver_onsite:     "Deliver Onsite",
    aramex:             "Aramex",
    delivery_hold:      "Delivery Hold",
    mohe_validation:    "MOHE Validation",
    mohe:               "MOHE",
    done:               "Done",
  };
  const stateLabel = (s) => STATE_LABELS[s] || s || "";

  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString("en-GB");
  };
  const isInRange = (d) => !!d && d >= dateFrom && d <= dateTo;
  const isRestricted = (r) => Number(r.restricted) === 1;

  // Per-state counts, dynamic — this report isn't scoped to a fixed set of
  // states, so tally whatever states actually appear in the data.
  const stateMap = {};
  rows.forEach((r) => {
    const key = r.state || "unknown";
    stateMap[key] = (stateMap[key] || 0) + 1;
  });
  const stateRows = Object.entries(stateMap)
    .map(([state, count]) => ({ state, label: stateLabel(state), count }))
    .sort((a, b) => b.count - a.count);
  const restrictedStudents = rows.filter(isRestricted).length;

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Missing Enrollment Letters");
  const COL_WIDTHS = [22, 30, 18, 18, 16, 18, 34, 22, 20];
  COL_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });
  const NUM_COLS = COL_WIDTHS.length;

  // ── Title banners ──
  schAddBanner(sheet, "Missing Enrollment Letters Report", NUM_COLS, SCH_DARK, 34, 18);
  schAddBanner(sheet, `Invoice Date Range:   ${fmtInputDate(dateFrom)}  →  ${fmtInputDate(dateTo)}`, NUM_COLS, "FFD6E4F0", 20, 11, SCH_DARK, true);
  schAddBanner(sheet, `Total Students: ${rows.length}`, NUM_COLS, "FFEAF0FB", 22, 12, SCH_DARK);
  sheet.addRow([]); // spacer

  // ── Summary block: count per state ──
  schAddBanner(sheet, "SUMMARY BY STATE", NUM_COLS, SCH_MID, 24, 13);
  const sumHdr = sheet.addRow(["State", "Student Count"]);
  sumHdr.height = 24;
  [1, 2].forEach((c) => schStyleHeader(sumHdr.getCell(c), SCH_MID));

  stateRows.forEach((sr, idx) => {
    const r = sheet.addRow([sr.label, sr.count]);
    r.height = 20;
    const bg = idx % 2 === 0 ? SCH_EVEN : "FFFFFFFF";
    [1, 2].forEach((c) => {
      schStyleData(r.getCell(c), bg);
      r.getCell(c).alignment = { vertical: "middle", horizontal: c === 1 ? "left" : "center" };
    });
  });

  // Total row
  const totRow = sheet.addRow(["TOTAL", rows.length]);
  totRow.height = 22;
  [1, 2].forEach((c) => {
    const cell = totRow.getCell(c);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: SCH_DARK } };
    cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: c === 1 ? "left" : "center" };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  });

  // Restricted-schools count row (red highlight)
  const restrictedRow = sheet.addRow(["Students in Restricted Schools", restrictedStudents]);
  restrictedRow.height = 22;
  [1, 2].forEach((c) => {
    const cell = restrictedRow.getCell(c);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: SCH_RED_DARK } };
    cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: c === 1 ? "left" : "center" };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  });
  sheet.addRow([]); // spacer

  // ── Detail table ──
  schAddBanner(sheet, "STUDENT DETAILS", NUM_COLS, "FF1D6A38", 24, 13);
  const hdr = sheet.addRow([
    "National ID", "Full Name", "Phone Number", "State",
    "Invoice Date", "Another Invoice Date", "School Name", "School City", "School Country",
  ]);
  hdr.height = 26;
  hdr.eachCell((cell) => schStyleHeader(cell, "FF1D6A38"));

  rows.forEach((r, idx) => {
    const restricted = isRestricted(r);
    const invoiceInRange = isInRange(r.invoice_date);
    const anotherInRange = isInRange(r.another_invoice_date);
    const dr = sheet.addRow([
      r.national_id || "",
      r.full_name || "",
      r.phone || "",
      stateLabel(r.state),
      invoiceInRange ? fmtDate(r.invoice_date) : "",
      anotherInRange ? fmtDate(r.another_invoice_date) : "",
      r.school_name || "",
      r.school_city || "",
      r.school_country || "",
    ]);
    dr.height = 20;
    // Restricted-school students get the red fill + bold dark-red text.
    const bg = restricted
      ? (idx % 2 === 0 ? SCH_RED_FILL : SCH_RED_ALT)
      : (idx % 2 === 0 ? SCH_EVEN : "FFFFFFFF");
    const fontArgb = restricted ? SCH_RED_DARK : "FF000000";
    dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
      schStyleData(cell, bg, fontArgb);
      if (colNum === 2 || colNum === 7) cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      if (restricted) cell.font = { size: 11, name: "Calibri", bold: true, color: { argb: SCH_RED_DARK } };
    });
  });

  if (rows.length === 0) {
    const emptyRow = sheet.addRow(["No students with a missing enrollment letter found."]);
    sheet.mergeCells(emptyRow.number, 1, emptyRow.number, NUM_COLS);
    emptyRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    emptyRow.getCell(1).font = { italic: true, size: 11, name: "Calibri", color: { argb: "FF888888" } };
  }

  sheet.views = [{ showGridLines: true }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Missing_Enrollment_Letters_${dateFrom}_to_${dateTo}.xlsx`);
}

// ================================================================
// QR Codes Report — total/used/remaining summary, the highest-numbered
// used code, and a breakdown of how many codes were marked used on each
// date. `summary` and `usedByDate` are the already-fetched response from
// GET /qrcodes/report (see getQrCodesReport in api/index.js).
// ================================================================
export async function excelQrCodesReport(summary, usedByDate) {
  const rows = Array.isArray(usedByDate) ? usedByDate : [];
  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString("en-GB");
  };

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("QR Codes Report");
  const COL_WIDTHS = [24, 20];
  COL_WIDTHS.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });
  const NUM_COLS = COL_WIDTHS.length;

  // ── Title + summary banners ──
  schAddBanner(sheet, "QR Codes Report", NUM_COLS, SCH_DARK, 34, 18);
  schAddBanner(sheet, `Generated: ${new Date().toLocaleString("en-GB")}`, NUM_COLS, "FFD6E4F0", 20, 11, SCH_DARK, true);
  schAddBanner(sheet, `Total: ${summary?.total ?? 0}   |   Used: ${summary?.used ?? 0}   |   Remaining: ${summary?.remaining ?? 0}`, NUM_COLS, "FFEAF0FB", 22, 12, SCH_DARK);
  schAddBanner(sheet, `Last Used Code: ${summary?.lastUsedCode || "—"}`, NUM_COLS, "FFFFEB9C", 22, 12, "FF7A5D00");
  sheet.addRow([]); // spacer

  // ── Used By Date table ──
  schAddBanner(sheet, "USED BY DATE", NUM_COLS, SCH_MID, 24, 13);
  const hdr = sheet.addRow(["Date", "Used Count"]);
  hdr.height = 24;
  [1, 2].forEach((c) => schStyleHeader(hdr.getCell(c), SCH_MID));

  rows.forEach((r, idx) => {
    const dr = sheet.addRow([fmtDate(r.used_date), r.count]);
    dr.height = 20;
    const bg = idx % 2 === 0 ? SCH_EVEN : "FFFFFFFF";
    [1, 2].forEach((c) => {
      schStyleData(dr.getCell(c), bg);
      dr.getCell(c).alignment = { vertical: "middle", horizontal: c === 1 ? "left" : "center" };
    });
  });

  const totalUsed = rows.reduce((sum, r) => sum + Number(r.count || 0), 0);
  const totRow = sheet.addRow(["TOTAL", totalUsed]);
  totRow.height = 22;
  [1, 2].forEach((c) => {
    const cell = totRow.getCell(c);
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: SCH_DARK } };
    cell.font = { bold: true, size: 11, name: "Calibri", color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: c === 1 ? "left" : "center" };
    cell.border = {
      top: { style: "medium" }, left: { style: "thin" },
      bottom: { style: "medium" }, right: { style: "thin" },
    };
  });

  if (rows.length === 0) {
    const emptyRow = sheet.addRow(["No QR codes have been marked used yet."]);
    sheet.mergeCells(emptyRow.number, 1, emptyRow.number, NUM_COLS);
    emptyRow.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    emptyRow.getCell(1).font = { italic: true, size: 11, name: "Calibri", color: { argb: "FF888888" } };
  }

  sheet.views = [{ showGridLines: true }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `QR_Codes_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
}


// ================================================================
// All Top Achievers page export — ACT1 + ACT2 sheets using exactly the
// filters currently applied on screen, including each student's comment.
// ================================================================
export async function excelAllTopAchievers(
  dateFrom,
  dateTo,
  scoreFrom = 30,
  scoreTo = 36,
  city = "",
  eventLocation = "",
  search = ""
) {
  const [resAct1, resAct2] = await Promise.all([
    exportAct1TopAchieversReport(dateFrom, dateTo, scoreFrom, scoreTo, city, eventLocation),
    exportAct2TopAchieversReport(dateFrom, dateTo, scoreFrom, scoreTo, city, eventLocation),
  ]);

  if (!resAct1 || resAct1.status !== 200) {
    alert("Failed to fetch ACT 1 data. Please try again.");
    return;
  }
  if (!resAct2 || resAct2.status !== 200) {
    alert("Failed to fetch ACT 2 data. Please try again.");
    return;
  }

  // Mirror the page's client-side search so the workbook matches what the
  // user is looking at when they hit Export.
  const term = String(search || "").trim().toLowerCase();
  const applySearch = (rows) =>
    !term
      ? rows
      : rows.filter(
          (r) =>
            String(r["National ID"] || "").toLowerCase().includes(term) ||
            String(r["Full Name"] || "").toLowerCase().includes(term)
        );

  const act1Rows = applySearch(resAct1.data?.data || []);
  const act2Rows = applySearch(resAct2.data?.data || []);

  const fmt = (val) => (val ? String(val).slice(0, 10) : "");

  // Top Achievers fee actually charged, matching the on-screen mark. The USD
  // list mirrors USD_CATEGORIES in Server/src/utils/pricing.js.
  const USD_CATEGORIES = ["outside", "outsideA", "foreignUsd"];
  const feeText = (r) => {
    if (!(Number(r["Fee Paid"]) > 0)) return "";
    const amount = Number(r["Fee Amount"]) || 0;
    if (!amount) return "Paid";
    const currency = USD_CATEGORIES.includes(r["Category"]) ? "USD" : "EGP";
    return `${Number.isInteger(amount) ? amount : amount.toFixed(2)} ${currency}`;
  };

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Authentication System";
  workbook.created = new Date();

  const styleHeader = (cell, argb) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb } };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12, name: "Calibri" };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  };
  const styleData = (cell, bgArgb) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    cell.font = { size: 11, name: "Calibri" };
    cell.border = {
      top:    { style: "thin", color: { argb: "FFD0D7E5" } },
      left:   { style: "thin", color: { argb: "FFD0D7E5" } },
      bottom: { style: "thin", color: { argb: "FFD0D7E5" } },
      right:  { style: "thin", color: { argb: "FFD0D7E5" } },
    };
  };
  const addInfoRow = (sheet, text, cols, bgArgb, fontOpts, height = 20) => {
    const r = sheet.addRow([text]);
    sheet.mergeCells(r.number, 1, r.number, cols);
    r.height = height;
    r.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgArgb } };
    r.getCell(1).font = { name: "Calibri", size: 11, ...fontOpts };
    r.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
    return r;
  };

  const filterLine =
    `Authentication Date: ${fmt(dateFrom)} → ${fmt(dateTo)}   |   ` +
    `Grade Range: ${scoreFrom} → ${scoreTo}   |   ` +
    `School City: ${city || "All"}   |   Event Location: ${eventLocation || "All"}` +
    (term ? `   |   Search: "${search.trim()}"` : "");

  const locationLine = (rows) => {
    const cairo = rows.filter((r) => r["Event Location"] === "Cairo").length;
    const alex = rows.filter((r) => r["Event Location"] === "Alexandria").length;
    return `Students: ${rows.length}   |   Cairo: ${cairo}   |   Alexandria: ${alex}   |   Not Set: ${rows.length - cairo - alex}`;
  };

  // ---- Sheet 1: ACT 1 ----
  const act1Sheet = workbook.addWorksheet("ACT1 Top Achievers");
  const ACT1_WIDTHS = [20, 30, 18, 18, 10, 22, 35, 20, 26, 40, 22];
  ACT1_WIDTHS.forEach((w, i) => { act1Sheet.getColumn(i + 1).width = w; });
  const ACT1_COLS = ACT1_WIDTHS.length;

  addInfoRow(act1Sheet, "ACT 1 Top Achievers", ACT1_COLS, "FF1A5276",
    { bold: true, color: { argb: "FFFFFFFF" }, size: 16 }, 34);
  addInfoRow(act1Sheet, filterLine, ACT1_COLS, "FFD6E4F7",
    { italic: true, color: { argb: "FF1E3A5F" } }, 22);
  addInfoRow(act1Sheet, locationLine(act1Rows), ACT1_COLS, "FFEAF0FB",
    { bold: true, color: { argb: "FF1E3A5F" } }, 22);
  act1Sheet.addRow([]);

  const act1Hdr = act1Sheet.addRow([
    "National ID", "Full Name", "Phone Number", "Event Location", "Score",
    "Authentication Date", "School Name", "School City", "Grade Status", "Comment",
    "Top Achievers Fee",
  ]);
  act1Hdr.height = 28;
  act1Hdr.eachCell((cell) => styleHeader(cell, "FF1A5276"));
  const act1HdrNum = act1Hdr.number;

  act1Rows.forEach((r, index) => {
    const dr = act1Sheet.addRow([
      r["National ID"], r["Full Name"], r["Phone Number"],
      r["Event Location"] || "Not Set", r["Score"],
      fmt(r["Authentication Date"]), r["School Name"], r["School City"],
      r["Grade Status"], r["Comment"] || "", feeText(r),
    ]);
    dr.height = 22;
    const bg = index % 2 === 0 ? "FFE8F5E9" : "FFFFFFFF";
    dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
      styleData(cell, bg);
      cell.alignment = {
        vertical: "middle",
        horizontal: colNum === 2 || colNum === 10 ? "left" : "center",
        wrapText: true,
      };
    });
  });

  act1Sheet.views = [{
    state: "frozen", ySplit: act1HdrNum,
    topLeftCell: `A${act1HdrNum + 1}`, activeCell: `A${act1HdrNum + 1}`,
  }];

  // ---- Sheet 2: ACT 2 ----
  const act2Sheet = workbook.addWorksheet("ACT2 Top Achievers");
  const ACT2_WIDTHS = [20, 30, 18, 18, 22, 10, 22, 10, 22, 10, 22, 35, 20, 26, 40, 22];
  ACT2_WIDTHS.forEach((w, i) => { act2Sheet.getColumn(i + 1).width = w; });
  const ACT2_COLS = ACT2_WIDTHS.length;

  addInfoRow(act2Sheet, "ACT 2 Top Achievers", ACT2_COLS, "FF1E3A5F",
    { bold: true, color: { argb: "FFFFFFFF" }, size: 16 }, 34);
  addInfoRow(act2Sheet, filterLine, ACT2_COLS, "FFD6E4F7",
    { italic: true, color: { argb: "FF1E3A5F" } }, 22);
  addInfoRow(act2Sheet, locationLine(act2Rows), ACT2_COLS, "FFEAF0FB",
    { bold: true, color: { argb: "FF1E3A5F" } }, 22);
  act2Sheet.addRow([]);

  const act2Hdr = act2Sheet.addRow([
    "National ID", "Full Name", "Phone Number", "Event Location",
    "Subject 1", "Score 1", "Subject 2", "Score 2", "Subject 3", "Score 3",
    "Authentication Date", "School Name", "School City", "Grade Status", "Comment",
    "Top Achievers Fee",
  ]);
  act2Hdr.height = 28;
  act2Hdr.eachCell((cell) => styleHeader(cell, "FF1E3A5F"));
  const act2HdrNum = act2Hdr.number;

  act2Rows.forEach((r, index) => {
    const dr = act2Sheet.addRow([
      r["National ID"], r["Full Name"], r["Phone Number"],
      r["Event Location"] || "Not Set",
      r["Subject 1"], r["Score 1"], r["Subject 2"], r["Score 2"],
      r["Subject 3"], r["Score 3"],
      fmt(r["Authentication Date"]), r["School Name"], r["School City"],
      r["Grade Status"], r["Comment"] || "", feeText(r),
    ]);
    dr.height = 22;
    const bg = index % 2 === 0 ? "FFEAF0FB" : "FFFFFFFF";
    dr.eachCell({ includeEmpty: true }, (cell, colNum) => {
      styleData(cell, bg);
      cell.alignment = {
        vertical: "middle",
        horizontal: colNum === 2 || colNum === 15 ? "left" : "center",
        wrapText: true,
      };
    });
  });

  act2Sheet.views = [{
    state: "frozen", ySplit: act2HdrNum,
    topLeftCell: `A${act2HdrNum + 1}`, activeCell: `A${act2HdrNum + 1}`,
  }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `All_Top_Achievers_${new Date().toISOString().slice(0, 10)}.xlsx`);
}
